import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "aord" }
const _hoisted_2 = {
  class: "sui-card sui-card--flush aord__board",
  "data-tour": "admin-orders-table"
}
const _hoisted_3 = {
  class: "aord__filters",
  "aria-label": "주문 필터"
}
const _hoisted_4 = {
  class: "aord__filter-group",
  "data-tour": "admin-orders-status",
  role: "group",
  "aria-label": "주문 상태"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "aord__filter-label" }
const _hoisted_7 = { class: "aord__filter-count" }
const _hoisted_8 = {
  class: "aord__filter-group",
  "data-tour": "admin-orders-work",
  role: "group",
  "aria-label": "처리할 일"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "aord__filter-label" }
const _hoisted_11 = { class: "aord__filter-count" }
const _hoisted_12 = { class: "aord__filter-count" }
const _hoisted_13 = { class: "aord__account-mini-body" }
const _hoisted_14 = {
  class: "sui-toolbar aord__toolbar",
  "data-tour": "admin-orders-toolbar"
}
const _hoisted_15 = {
  class: "sui-presets",
  role: "group",
  "aria-label": "기간"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "sui-date" }
const _hoisted_18 = { class: "sui-date" }
const _hoisted_19 = { class: "sui-search" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "aord__error"
}
const _hoisted_23 = {
  key: 1,
  class: "aord__tax-hint"
}
const _hoisted_24 = {
  key: 2,
  class: "sui-table-wrap"
}
const _hoisted_25 = {
  key: 0,
  class: "sui-table aord__table--tax"
}
const _hoisted_26 = { class: "sui-table__strong" }
const _hoisted_27 = { class: "sui-table__sub" }
const _hoisted_28 = {
  key: 0,
  class: "aord__focus-tag"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "sui-table__sub" }
const _hoisted_32 = { class: "is-num" }
const _hoisted_33 = { class: "sui-table__strong aord__amount" }
const _hoisted_34 = { class: "is-center" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 1,
  class: "aord__sections"
}
const _hoisted_37 = { class: "aord__section-head" }
const _hoisted_38 = {
  class: "aord__section-icon",
  "aria-hidden": "true"
}
const _hoisted_39 = { class: "aord__section-title" }
const _hoisted_40 = { class: "aord__section-count" }
const _hoisted_41 = {
  key: 0,
  class: "aord__cards"
}
const _hoisted_42 = ["aria-expanded", "aria-controls", "onClick", "onKeydown"]
const _hoisted_43 = { class: "aord__card-head" }
const _hoisted_44 = {
  class: "aord__card-chevron",
  "aria-hidden": "true"
}
const _hoisted_45 = { class: "aord__card-code" }
const _hoisted_46 = { class: "aord__card-time" }
const _hoisted_47 = {
  key: 0,
  class: "aord__focus-tag"
}
const _hoisted_48 = { class: "aord__card-badges" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["title"]
const _hoisted_51 = {
  key: 2,
  class: "sui-badge aord__claim-chip",
  title: "카드를 펼쳐 상품행에서 승인·반려를 처리하세요"
}
const _hoisted_52 = {
  key: 3,
  class: "sui-badge aord__qna-chip",
  title: "이 주문에 미답변 상품문의가 있습니다"
}
const _hoisted_53 = ["title"]
const _hoisted_54 = ["title"]
const _hoisted_55 = ["title"]
const _hoisted_56 = { class: "aord__card-sum" }
const _hoisted_57 = { class: "aord__card-sum-goods" }
const _hoisted_58 = { class: "aord__card-sum-total" }
const _hoisted_59 = {
  key: 0,
  class: "aord__card-sum-note"
}
const _hoisted_60 = { class: "aord__amount" }
const _hoisted_61 = ["id"]
const _hoisted_62 = {
  key: 0,
  class: "aord__card-detail-loading"
}
const _hoisted_63 = {
  key: 1,
  class: "aord__error"
}
const _hoisted_64 = {
  key: 0,
  class: "aord__detail-strip"
}
const _hoisted_65 = {
  key: 0,
  class: "aord__detail-strip-meta"
}
const _hoisted_66 = {
  key: 1,
  class: "aord__detail-strip-reason"
}
const _hoisted_67 = { class: "aord__info-table" }
const _hoisted_68 = { class: "aord__info-group" }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = {
  key: 2,
  class: "aord__info-sub"
}
const _hoisted_71 = { key: 0 }
const _hoisted_72 = {
  key: 1,
  class: "aord__info-muted"
}
const _hoisted_73 = { colspan: "3" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { colspan: "3" }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = { colspan: "3" }
const _hoisted_78 = {
  key: 0,
  class: "aord__info-sub"
}
const _hoisted_79 = {
  key: 1,
  class: "aord__info-sub"
}
const _hoisted_80 = { colspan: "3" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = {
  key: 0,
  class: "aord__info-sub"
}
const _hoisted_83 = {
  key: 1,
  class: "aord__info-muted"
}
const _hoisted_84 = {
  key: 0,
  class: "aord__info-group"
}
const _hoisted_85 = { class: "aord__info-subhead" }
const _hoisted_86 = {
  colspan: "4",
  scope: "colgroup"
}
const _hoisted_87 = {
  key: 0,
  class: "aord__info-sub"
}
const _hoisted_88 = ["href"]
const _hoisted_89 = {
  key: 1,
  class: "aord__info-muted"
}
const _hoisted_90 = { key: 0 }
const _hoisted_91 = {
  key: 1,
  class: "aord__info-muted"
}
const _hoisted_92 = { key: 0 }
const _hoisted_93 = {
  key: 1,
  class: "aord__info-muted"
}
const _hoisted_94 = ["href"]
const _hoisted_95 = {
  key: 1,
  class: "aord__info-muted"
}
const _hoisted_96 = {
  key: 2,
  class: "aord__info-sub"
}
const _hoisted_97 = ["href"]
const _hoisted_98 = {
  key: 1,
  class: "aord__info-muted"
}
const _hoisted_99 = {
  key: 2,
  class: "aord__info-sub"
}
const _hoisted_100 = { key: 0 }
const _hoisted_101 = {
  colspan: "3",
  class: "aord__info-warn"
}
const _hoisted_102 = {
  key: 1,
  class: "aord__info-group"
}
const _hoisted_103 = { class: "aord__info-subhead" }
const _hoisted_104 = {
  colspan: "4",
  scope: "colgroup"
}
const _hoisted_105 = { class: "aord__info-more-note" }
const _hoisted_106 = { scope: "row" }
const _hoisted_107 = { colspan: "3" }
const _hoisted_108 = { class: "aord__qna-body" }
const _hoisted_109 = { class: "aord__items-table" }
const _hoisted_110 = { class: "aord__items-store" }
const _hoisted_111 = {
  colspan: "5",
  scope: "colgroup"
}
const _hoisted_112 = { class: "aord__items-store-name" }
const _hoisted_113 = { class: "is-item" }
const _hoisted_114 = {
  key: 0,
  class: "aord__items-option"
}
const _hoisted_115 = { class: "is-num" }
const _hoisted_116 = { class: "is-num is-qty" }
const _hoisted_117 = { class: "is-num is-strong" }
const _hoisted_118 = { class: "is-status" }
const _hoisted_119 = { class: "aord__items-status" }
const _hoisted_120 = ["title"]
const _hoisted_121 = ["title"]
const _hoisted_122 = ["title"]
const _hoisted_123 = {
  key: 3,
  class: "aord__items-actions"
}
const _hoisted_124 = ["disabled", "onClick"]
const _hoisted_125 = ["disabled", "onClick"]
const _hoisted_126 = ["onClick"]
const _hoisted_127 = ["onClick"]
const _hoisted_128 = ["onClick"]
const _hoisted_129 = {
  key: 0,
  class: "aord__items-claim-reason"
}
const _hoisted_130 = {
  key: 1,
  class: "aord__items-claim-reason is-reject"
}
const _hoisted_131 = { class: "aord__detail-foot" }
const _hoisted_132 = { class: "aord__memo" }
const _hoisted_133 = ["disabled"]
const _hoisted_134 = { class: "aord__totals-table" }
const _hoisted_135 = { class: "aord__platform" }
const _hoisted_136 = { scope: "row" }
const _hoisted_137 = { key: 0 }
const _hoisted_138 = { key: 1 }
const _hoisted_139 = {
  key: 2,
  class: "is-total"
}
const _hoisted_140 = { class: "aord__detail-actions" }
const _hoisted_141 = { class: "aord__card-hint" }
const _hoisted_142 = { class: "aord__card-buttons" }
const _hoisted_143 = ["disabled"]
const _hoisted_144 = ["disabled"]
const _hoisted_145 = {
  key: 1,
  class: "aord__section-empty"
}
const _hoisted_146 = {
  key: 3,
  class: "sui-empty"
}
const _hoisted_147 = { key: 0 }
const _hoisted_148 = { class: "aord__empty-title" }
const _hoisted_149 = { key: 2 }
const _hoisted_150 = { class: "aord__compare" }
const _hoisted_151 = { class: "aord__cancel-sub" }
const _hoisted_152 = { class: "aord__cancel-hint" }
const _hoisted_153 = { class: "sui-field" }
const _hoisted_154 = { class: "aord__panel-actions" }
const _hoisted_155 = ["disabled"]
const _hoisted_156 = { class: "aord__extra-sub" }
const _hoisted_157 = { class: "sui-field" }
const _hoisted_158 = ["value"]
const _hoisted_159 = { class: "sui-field" }
const _hoisted_160 = { class: "sui-field" }
const _hoisted_161 = ["max"]
const _hoisted_162 = { class: "sui-field" }
const _hoisted_163 = { class: "aord__extra-actions" }
const _hoisted_164 = ["disabled"]
const _hoisted_165 = { class: "aord__extra-sub" }
const _hoisted_166 = {
  key: 0,
  class: "aord__extra-note"
}
const _hoisted_167 = { class: "sui-field" }
const _hoisted_168 = { class: "aord__extra-actions" }
const _hoisted_169 = ["disabled"]
const _hoisted_170 = { class: "aord__refund-summary" }
const _hoisted_171 = { class: "aord__refund-summary-amount" }
const _hoisted_172 = { class: "aord__adjust-choices" }
const _hoisted_173 = { key: 0 }
const _hoisted_174 = {
  key: 0,
  class: "aord__adjust-status"
}
const _hoisted_175 = ["value"]
const _hoisted_176 = {
  key: 1,
  class: "aord__refund-fields"
}
const _hoisted_177 = ["value"]
const _hoisted_178 = { class: "is-full" }
const _hoisted_179 = { class: "aord__adjust-reason" }
const _hoisted_180 = { class: "aord__extra-actions" }
const _hoisted_181 = ["disabled"]
const _hoisted_182 = { class: "aord__refund-summary" }
const _hoisted_183 = { key: 0 }
const _hoisted_184 = { class: "aord__refund-summary-type" }
const _hoisted_185 = { class: "aord__refund-summary-amount" }
const _hoisted_186 = { class: "aord__extra-note" }
const _hoisted_187 = {
  key: 0,
  class: "aord__refund-fields"
}
const _hoisted_188 = ["value"]
const _hoisted_189 = { class: "is-full" }
const _hoisted_190 = { class: "aord__extra-actions" }
const _hoisted_191 = ["disabled"]
const _hoisted_192 = { class: "aord__panel aord__panel--tax" }
const _hoisted_193 = { class: "aord__panel-head" }
const _hoisted_194 = { class: "aord__panel-body" }
const _hoisted_195 = {
  key: 0,
  class: "aord__tax-modal-loading"
}
const _hoisted_196 = {
  key: 1,
  class: "aord__meta aord__tax-modal-meta"
}
const _hoisted_197 = ["href"]
const _hoisted_198 = {
  key: 1,
  class: "aord__tax-missing"
}
const _hoisted_199 = ["href"]
const _hoisted_200 = {
  key: 0,
  class: "aord__tax-note"
}
const _hoisted_201 = {
  key: 1,
  class: "aord__tax-missing"
}
const _hoisted_202 = ["href"]
const _hoisted_203 = {
  key: 0,
  class: "aord__tax-note"
}
const _hoisted_204 = {
  key: 1,
  class: "aord__tax-missing"
}
const _hoisted_205 = { key: 0 }
const _hoisted_206 = { key: 1 }
const _hoisted_207 = ["href"]
const _hoisted_208 = {
  key: 2,
  class: "aord__tax-issues"
}
const _hoisted_209 = {
  key: 3,
  class: "aord__tax-modal-hint"
}
const _hoisted_210 = {
  key: 4,
  class: "aord__tax-modal-hint"
}
const _hoisted_211 = {
  class: "aord__tax-modal-actions",
  "data-tour": "admin-orders-tax-action"
}
const _hoisted_212 = ["disabled"]
const _hoisted_213 = ["disabled"]
const _hoisted_214 = ["disabled"]
const _hoisted_215 = { class: "aord__panel aord__panel--tax-reject" }
const _hoisted_216 = { class: "aord__panel-head" }
const _hoisted_217 = { class: "aord__panel-body" }
const _hoisted_218 = { class: "aord__tax-reject-lead" }
const _hoisted_219 = { class: "aord__tax-reject-section" }
const _hoisted_220 = { class: "aord__tax-issues" }
const _hoisted_221 = { class: "aord__tax-reject-extra" }
const _hoisted_222 = { class: "aord__tax-reject-section" }
const _hoisted_223 = { class: "aord__tax-reject-sms" }
const _hoisted_224 = { class: "aord__tax-reject-send" }
const _hoisted_225 = { class: "aord__tax-modal-actions" }
const _hoisted_226 = ["disabled"]
const _hoisted_227 = { class: "aord__panel aord__panel--org" }
const _hoisted_228 = { class: "aord__panel-head" }
const _hoisted_229 = { key: 0 }
const _hoisted_230 = { class: "aord__panel-body" }
const _hoisted_231 = {
  key: 0,
  class: "aord__org-status"
}
const _hoisted_232 = {
  key: 1,
  class: "aord__org-status aord__org-status--error"
}
const _hoisted_233 = { class: "aord__org-section" }
const _hoisted_234 = { class: "aord__meta aord__meta--org" }
const _hoisted_235 = { class: "aord__meta-span" }
const _hoisted_236 = { key: 0 }
const _hoisted_237 = { class: "aord__org-section" }
const _hoisted_238 = { class: "aord__meta aord__meta--org" }
const _hoisted_239 = ["href"]
const _hoisted_240 = { key: 1 }
const _hoisted_241 = { class: "aord__meta-span" }
const _hoisted_242 = { class: "aord__org-section" }
const _hoisted_243 = { class: "aord__meta aord__meta--org" }
const _hoisted_244 = {
  key: 1,
  class: "aord__org-sub"
}
const _hoisted_245 = { class: "aord__org-section" }
const _hoisted_246 = { class: "aord__org-section-title" }
const _hoisted_247 = { key: 0 }
const _hoisted_248 = {
  key: 0,
  class: "aord__org-status"
}
const _hoisted_249 = { class: "aord__org-tax-head" }
const _hoisted_250 = { class: "aord__meta aord__meta--org" }
const _hoisted_251 = ["href"]
const _hoisted_252 = { key: 1 }
const _hoisted_253 = {
  key: 2,
  class: "aord__tax-note"
}
const _hoisted_254 = ["href"]
const _hoisted_255 = { key: 1 }
const _hoisted_256 = {
  key: 2,
  class: "aord__tax-note"
}
const _hoisted_257 = { key: 0 }
const _hoisted_258 = {
  key: 1,
  class: "aord__meta-span"
}
const _hoisted_259 = ["href"]
const _hoisted_260 = {
  key: 2,
  class: "aord__meta-span"
}

import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import MallShipmentLedger from '@/components/mall/MallShipmentLedger.vue'
import MallTrackingModal from '@/components/mall/MallTrackingModal.vue'
import { useMallTracking } from '@/composables/useMallTracking'
import { useAdminProducts } from '@/composables/useAdminProducts'
import { confirmDialog } from '@/composables/useConfirmDialog'
import { useListDateRange } from '@/composables/useListDateRange'
import { MALL_COURIERS as COURIERS, isKnownMallCourier } from '@/constants/mallCouriers'
import { formatWon } from '@/constants/sellerData'
import {
  MALL_ORDER_ITEM_STATUS_LABEL,
  MALL_ORDER_STATUS_LABEL,
  cancelOrderByAdmin,
  confirmOrderPayment,
  unconfirmOrderPayment,
  fetchAdminOrder,
  fetchAdminOrders,
  fetchPaymentInfo,
  saveAdminOrderMemo,
  saveAdminTaxStatus,
  rejectAdminTaxInvoice,
  createAdminExtraShipment,
  markAdminRefundDone,
  adjustAdminOrderItem,
  approveAdminClaim,
  rejectAdminClaim,
  mallPayMethodLabel,
  mallOrderRefundTotals,
  MALL_TAX_STATUS_LABEL,
  type AdminMallOrder,
  type MallOrderItemStatus,
  type MallOrderItemWithMargin,
  type MallPaymentInfo,
  type OrderStatusCounts,
  type AdminAdjustAction,
} from '@/api/mallOrder'
import { MALL_BANKS } from '@/constants/banks'
import {
  buildTaxRejectSms,
  listTaxInvoiceIssues,
  orderHasDelivered,
} from '@/utils/taxInvoiceIssues'
import { isExistingWaybill, type ShipmentLedgerRow } from '@/utils/mallShipment'
import { formatKrPhone } from '@/utils/formatPhone'
import { formatBizNumber } from '@/utils/bizNumber'
import type { DatePresetKey } from '@/utils/dateInput'
import {
  PENDING_EXPIRE_DAYS,
  pendingExpireLabel,
  pendingExpireTone,
} from '@/utils/mallOpsUx'
import { fetchAdminMember, type AdminMemberRow, type AdminMemberTaxRequest } from '@/api/admin'

const LAST_COURIER_KEY = 'admin-orders:lastCourier'

type ExtraShipItem = MallOrderItemWithMargin & { orderCode?: string }
type OrderSectionKey = 'notified' | 'unnotified' | 'shipping' | 'done' | 'canceled'
type WorkFilterKey = 'refund' | 'claim'

/**
 * 기존 URL을 생명주기 키로 변환한다.
 * section=unpaid&notified=1 → 입금 알림, section=unpaid → 입금 미진행.
 * section=refund 는 처리할 일(work=refund)로 옮겼다.
 */
interface OrderSectionMeta {
  key: OrderSectionKey
  title: string
  desc: string
  icon: string
  tone: 'red' | 'amber' | 'violet' | 'blue' | 'gray' | 'slate'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminOrdersPage',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const { notify } = useAdminProducts()
/*
 * 관리자 주문 화면은 건수가 많아 기본 기간이 넓을수록 첫 로딩이 눈에 띄게 늘어난다.
 * 관리자가 실제로 자주 보는 것은 최근 1개월이라, 초기 조회 부담을 낮추기 위해 기본을 1개월로 둔다.
 * 더 긴 기간이 필요하면 프리셋을 눌러 넓히면 된다.
 */
const { fromDate, toDate, preset, presets, applyPreset, onManualDateChange } = useListDateRange('1m')

/*
 * 다른 화면(문의·정산·클레임 등)에서 「관련 주문」 링크로 넘어올 때는 주문번호가 정확히 오므로
 * 기본 1개월 필터에 걸려 빈 화면이 뜨는 일을 막는다. keyword 만 있고 기간 프리셋이 명시되지
 * 않았으면 「전체」로 자동 확장한다.
 *
 * setup 최초 진입 뿐 아니라, 같은 라우트 안에서 query만 바뀌는 경우
 * (예: 이미 /admin/orders 를 열어 둔 상태에서 CS의 「관련 주문」 링크를 다시 눌러도
 *  Vue router는 컴포넌트를 재사용하므로 setup이 재실행되지 않는다) 에도
 * 아래 watch가 다시 「전체」로 넓혀 준다.
 */
function expandRangeForDeepLink() {
  const kw = String(route.query.keyword ?? '').trim()
  if (!kw) return
  if (route.query.preset) return
  // 이미 「전체」면 재적용 불필요
  if (preset.value === 'all' && !fromDate.value && !toDate.value) return
  applyPreset('all')
}
expandRangeForDeepLink()

const orders = ref<AdminMallOrder[]>([])
const counts = ref<OrderStatusCounts>({})
const payment = ref<MallPaymentInfo | null>(null)
const expandedCode = ref('')
const expandedDetail = ref<AdminMallOrder | null>(null)
const expandedLoading = ref(false)
const expandedError = ref('')
const taxTarget = ref<AdminMallOrder | null>(null)
const taxLoading = ref(false)
const taxRejectTarget = ref<AdminMallOrder | null>(null)
const taxRejectExtra = ref('')
const taxRejectSms = ref('')
const taxRejectSendSms = ref(true)

const orgModalOpen = ref(false)
const orgLoading = ref(false)
const orgError = ref('')
const orgDetail = ref<AdminMemberRow | null>(null)
const orgFocusOrderCode = ref('')
const orgTaxRequests = computed<AdminMemberTaxRequest[]>(() => orgDetail.value?.taxRequests || [])
const { trackTarget, openTracking, closeTracking } = useMallTracking()
const cancelTarget = ref<AdminMallOrder | null>(null)

/* ---- 추가발송(관리자 대리 등록) ---- */
const extraShipTarget = ref<ExtraShipItem | null>(null)
const extraShipForm = reactive({
  courier: loadLastCourier(),
  invoice: '',
  qty: 1,
  memo: '오발송·누락 재발송',
})
const extraShipBusy = ref(false)

function loadLastCourier(): string {
  try {
    const raw = localStorage.getItem(LAST_COURIER_KEY)
    if (raw && isKnownMallCourier(raw)) return raw
  } catch {
    /* ignore */
  }
  return COURIERS[0]
}
function saveLastCourier(name: string) {
  try {
    localStorage.setItem(LAST_COURIER_KEY, name)
  } catch {
    /* ignore */
  }
}
function isDirectCourierName(courier: string) {
  return /직접/.test(courier || '')
}
function canExtraShip(item: MallOrderItemWithMargin) {
  return item.status === 'SHIPPING' || item.status === 'DELIVERED' || item.status === 'DONE'
}
function hasItemShipmentUi(item: MallOrderItemWithMargin) {
  return Boolean(item.invoice || item.shipments?.length || canExtraShip(item))
}
function hasItemPrimaryActions(item: MallOrderItemWithMargin) {
  return (
    isClaimPending(item) ||
    item.refundStatus === 'PENDING' ||
    (canAdminAdjust(item) && !hasItemShipmentUi(item))
  )
}
function openItemShipment(item: MallOrderItemWithMargin, row: ShipmentLedgerRow) {
  openTracking({
    idx: item.idx,
    courier: row.courier,
    invoice: row.invoice,
    name: item.name,
    orderCode: expandedDetail.value?.code,
  })
}
function openExtraShip(item: MallOrderItemWithMargin) {
  extraShipTarget.value = { ...item, orderCode: expandedDetail.value?.code }
  extraShipForm.courier = loadLastCourier()
  extraShipForm.invoice = ''
  extraShipForm.qty = 1
  extraShipForm.memo = '오발송·누락 재발송'
}
async function submitExtraShip() {
  if (!extraShipTarget.value || extraShipBusy.value) return
  const target = extraShipTarget.value
  const courier = extraShipForm.courier
  const invoice = extraShipForm.invoice.trim()
  const direct = isDirectCourierName(courier)
  const qty = Math.max(1, Math.trunc(Number(extraShipForm.qty) || 1))
  const memo = extraShipForm.memo.trim() || '오발송·누락 재발송'

  if (!direct && !invoice) {
    notify('추가 송장번호를 입력해 주세요. 직접배송은 생략할 수 있습니다.')
    return
  }
  if (!direct && isExistingWaybill(target, invoice)) {
    notify('이미 있는 송장입니다. 택배를 따로 보냈을 때만 다른 송장을 넣어 주세요.')
    return
  }
  if (qty > target.qty) {
    notify(`추가 수량은 주문 수량(${target.qty})을 넘을 수 없습니다.`)
    return
  }

  const ok = await confirmDialog({
    title: '재발송 등록',
    message: `${target.orderCode || expandedDetail.value?.code || ''} 주문에 재발송 송장을 추가할까요? 주문번호는 그대로입니다.`,
    detail: `${target.storeName}\n${target.name}\n${courier}${
      invoice ? `\n송장 ${invoice}` : '\n송장 없음(직접배송)'
    }\n수량 ${qty}\n사유 ${memo}`,
    confirmLabel: '등록',
    tone: 'primary',
  })
  if (!ok) return

  extraShipBusy.value = true
  try {
    await createAdminExtraShipment(target.idx, { courier, invoice, qty, memo })
    saveLastCourier(courier)
    notify('재발송 송장을 등록했습니다. 주문번호는 그대로입니다.')
    extraShipTarget.value = null
    await refreshExpanded()
    await reload()
  } catch (error) {
    notify(error instanceof Error ? error.message : '재발송 등록에 실패했습니다.')
  } finally {
    extraShipBusy.value = false
  }
}

/* ---- 환불 완료 처리(관리자) ---- */
const refundTarget = ref<MallOrderItemWithMargin | null>(null)
const refundForm = reactive({
  bank: '',
  account: '',
  holder: '',
  memo: '',
})
const refundBusy = ref(false)

function openRefundDone(item: MallOrderItemWithMargin) {
  refundTarget.value = item
  refundForm.bank = item.refundBank || ''
  refundForm.account = item.refundAccount || ''
  refundForm.holder = item.refundHolder || ''
  refundForm.memo = ''
}
function closeRefundDone() {
  refundTarget.value = null
}
function refundClaimLabelOf(item: MallOrderItemWithMargin) {
  if (item.claimType === 'RETURN') return '반품 환불'
  if (item.claimType === 'CANCEL') return '취소 환불'
  return '관리자 취소 환불'
}

const ADMIN_ADJUST_STATUSES: { value: MallOrderItemStatus; label: string }[] = [
  { value: 'PAID', label: '신규 주문' },
  { value: 'READY', label: '발송 준비' },
  { value: 'SHIPPING', label: '배송중' },
  { value: 'DELIVERED', label: '배송완료' },
  { value: 'DONE', label: '구매확정' },
]
const adjustTarget = ref<MallOrderItemWithMargin | null>(null)
const adjustBusy = ref(false)
const adjustForm = reactive({
  action: 'refund-done' as AdminAdjustAction,
  status: 'READY' as MallOrderItemStatus,
  reason: '',
  bank: '',
  account: '',
  holder: '',
})

function canAdminAdjust(item: MallOrderItemWithMargin) {
  return item.status !== 'WAITING' && item.refundStatus !== 'DONE'
}
function openAdjust(item: MallOrderItemWithMargin) {
  const flow = ADMIN_ADJUST_STATUSES.some((row) => row.value === item.status)
    ? item.status
    : item.claimPrevStatus && ADMIN_ADJUST_STATUSES.some((row) => row.value === item.claimPrevStatus)
      ? (item.claimPrevStatus as MallOrderItemStatus)
      : 'READY'
  adjustTarget.value = item
  adjustForm.action = 'refund-done'
  adjustForm.status = flow
  adjustForm.reason = ''
  adjustForm.bank = item.refundBank || ''
  adjustForm.account = item.refundAccount || ''
  adjustForm.holder =
    item.refundHolder || expandedDetail.value?.depositor || ''
}
function closeAdjust() {
  adjustTarget.value = null
}
const canSubmitAdjust = computed(() => {
  if (adjustBusy.value || !adjustForm.reason) return false
  if (adjustForm.action === 'refund-done') {
    if (expandedDetail.value?.payMethod === 'TOSS') return true
    return Boolean(adjustForm.bank && adjustForm.account && adjustForm.holder)
  }
  if (adjustForm.action === 'status') {
    return Boolean(adjustForm.status)
  }
  return true
})
const adjustSubmitLabel = computed(() => {
  if (adjustForm.action === 'refund-done') {
    return expandedDetail.value?.payMethod === 'TOSS' ? '카드 결제 취소' : '환불 완료로 표시'
  }
  if (adjustForm.action === 'refund-pending') return '환불 대기로 두기'
  return '상태 바꾸기'
})

async function submitAdjust() {
  if (!adjustTarget.value || !canSubmitAdjust.value) return
  const target = adjustTarget.value
  const action = adjustForm.action
  const statusLabel =
    ADMIN_ADJUST_STATUSES.find((row) => row.value === adjustForm.status)?.label || adjustForm.status
  const ok = await confirmDialog({
    title: action === 'status' ? '배송 상태 변경' : '환불 처리',
    message:
      action === 'refund-done'
        ? expandedDetail.value?.payMethod === 'TOSS'
          ? '이 상품을 취소하고 결제했던 카드·간편결제로 환불할까요? 되돌릴 수 없습니다.'
          : '이 상품을 취소하고 환불 완료로 표시할까요? 되돌릴 수 없습니다.'
        : action === 'refund-pending'
          ? '이 상품을 취소하고 환불 대기로 둘까요?'
          : `배송 상태를 「${statusLabel}」로 바꿀까요?`,
    detail: [
      expandedDetail.value?.code,
      target.name,
      `${formatWon(target.refundAmount || target.amount || 0)}원`,
      adjustForm.reason,
    ]
      .filter(Boolean)
      .join('\n'),
    confirmLabel: adjustSubmitLabel.value,
    tone: action === 'status' ? 'primary' : 'danger',
  })
  if (!ok) return

  adjustBusy.value = true
  try {
    const message = await adjustAdminOrderItem(target.idx, {
      action,
      status: action === 'status' ? adjustForm.status : undefined,
      reason: adjustForm.reason,
      refundBank: adjustForm.bank,
      refundAccount: adjustForm.account,
      refundHolder: adjustForm.holder,
      memo: adjustForm.reason,
    })
    notify(message)
    adjustTarget.value = null
    await refreshExpanded()
    await reload()
  } catch (error) {
    notify(error instanceof Error ? error.message : '주문 조정에 실패했습니다.')
  } finally {
    adjustBusy.value = false
  }
}

/* ---- 취소·반품 승인/반려(클레임 처리) ---- */
const claimRejectTarget = ref<MallOrderItemWithMargin | null>(null)
const claimRejectReason = ref('')
const claimBusy = ref(0)

function isClaimPending(item: MallOrderItemWithMargin) {
  return item.status === 'CANCEL_REQUEST' || item.status === 'RETURN_REQUEST'
}
function isItemActionBusy(item: MallOrderItemWithMargin) {
  return isClaimPending(item) || item.refundStatus === 'PENDING'
}
function isClaimRejected(item: MallOrderItemWithMargin) {
  return Boolean(item.claimRejectReason) && !isClaimPending(item) && item.status !== 'CANCELED'
}
function claimRequestLabel(item: MallOrderItemWithMargin) {
  if (item.status === 'CANCEL_REQUEST') return '취소 요청'
  if (item.status === 'RETURN_REQUEST') return '반품 요청'
  if (item.claimType === 'CANCEL') return '취소 처리'
  if (item.claimType === 'RETURN') return '반품 처리'
  return '클레임'
}
function claimAgeHoursOf(item: MallOrderItemWithMargin): number {
  if (!item.claimAt) return 0
  const ms = Date.now() - new Date(item.claimAt).getTime()
  return Math.max(0, Math.floor(ms / 3600000))
}
function claimSlaLabel(item: MallOrderItemWithMargin) {
  const hours = claimAgeHoursOf(item)
  if (!hours) return '방금'
  if (hours < 24) return `${hours}시간 경과`
  const days = Math.floor(hours / 24)
  return `${days}일 경과`
}
function claimSlaTone(item: MallOrderItemWithMargin): '' | 'warn' | 'alert' {
  const hours = claimAgeHoursOf(item)
  if (hours >= 48) return 'alert'
  if (hours >= 24) return 'warn'
  return ''
}

async function approveClaim(item: MallOrderItemWithMargin) {
  if (claimBusy.value) return
  const isCancel = item.status === 'CANCEL_REQUEST'
  const label = isCancel ? '취소 요청 승인' : '반품 요청 승인'
  const detail = [
    expandedDetail.value?.code,
    item.storeName,
    `${item.name} · ${item.qty}개`,
    `${formatWon(item.refundAmount || item.amount)}원`,
    item.claimType === 'RETURN'
      ? item.returnCause === 'CHANGE'
        ? `단순 변심 · 판매자 반품비 ${formatWon(item.appliedReturnFee || 0)}원`
        : '하자·오배송 · 판매자 상품 정산 없음'
      : '',
    item.claimReason ? `사유: ${item.claimReason}` : '',
    isCancel
      ? expandedDetail.value?.payMethod === 'TOSS'
        ? '재고가 자동 복구되고, 결제했던 카드·간편결제로 환불됩니다.'
        : '재고가 자동 복구되고, 환불 대기로 잡힙니다.'
      : expandedDetail.value?.payMethod === 'TOSS'
        ? '반품은 재고가 자동 복구되지 않습니다. 결제했던 카드·간편결제로 환불됩니다.'
        : '반품은 재고가 자동 복구되지 않습니다. 환불 대기로 잡힙니다.',
  ]
    .filter(Boolean)
    .join('\n')

  const ok = await confirmDialog({
    title: label,
    message: `${label} 처리할까요?`,
    detail,
    confirmLabel: '승인',
    tone: 'primary',
  })
  if (!ok) return

  claimBusy.value = item.idx
  try {
    const message = await approveAdminClaim(item.idx)
    notify(message || '승인했습니다.')
    await refreshExpanded()
    await reload()
  } catch (error) {
    notify(error instanceof Error ? error.message : '승인에 실패했습니다.')
  } finally {
    claimBusy.value = 0
  }
}

function openClaimReject(item: MallOrderItemWithMargin) {
  claimRejectTarget.value = item
  claimRejectReason.value = ''
}
function closeClaimReject() {
  claimRejectTarget.value = null
  claimRejectReason.value = ''
}
async function submitClaimReject() {
  if (!claimRejectTarget.value || claimBusy.value) return
  const target = claimRejectTarget.value
  const reason = claimRejectReason.value.trim()
  if (!reason) {
    notify('반려 사유를 입력해 주세요.')
    return
  }

  const ok = await confirmDialog({
    title: '클레임 반려',
    message: `${claimRequestLabel(target)}을(를) 반려할까요?`,
    detail: [
      expandedDetail.value?.code,
      target.storeName,
      `${target.name} · ${target.qty}개`,
      `반려 사유: ${reason}`,
      '이전 배송 상태로 되돌립니다.',
    ]
      .filter(Boolean)
      .join('\n'),
    confirmLabel: '반려',
    tone: 'danger',
  })
  if (!ok) return

  claimBusy.value = target.idx
  try {
    const message = await rejectAdminClaim(target.idx, reason)
    notify(message || '반려했습니다.')
    claimRejectTarget.value = null
    claimRejectReason.value = ''
    await refreshExpanded()
    await reload()
  } catch (error) {
    notify(error instanceof Error ? error.message : '반려에 실패했습니다.')
  } finally {
    claimBusy.value = 0
  }
}

async function submitRefundDone() {
  if (!refundTarget.value || refundBusy.value) return
  if (!refundForm.bank || !refundForm.account || !refundForm.holder) return
  const target = refundTarget.value

  const ok = await confirmDialog({
    title: '환불 송금 완료',
    message: '이 건을 송금 완료로 표시할까요?',
    detail: [
      expandedDetail.value?.code,
      target.name,
      `${formatWon(target.refundAmount || target.amount || 0)}원`,
      `${refundForm.bank} ${refundForm.account} (${refundForm.holder})`,
    ]
      .filter(Boolean)
      .join('\n'),
    confirmLabel: '송금 완료',
    tone: 'primary',
  })
  if (!ok) return

  refundBusy.value = true
  try {
    await markAdminRefundDone(target.idx, {
      memo: refundForm.memo,
      refundBank: refundForm.bank,
      refundAccount: refundForm.account,
      refundHolder: refundForm.holder,
    })
    notify('환불 완료로 표시했습니다.')
    refundTarget.value = null
    await refreshExpanded()
    await reload()
  } catch (error) {
    notify(error instanceof Error ? error.message : '환불 완료 처리에 실패했습니다.')
  } finally {
    refundBusy.value = false
  }
}

function trackItemsOf(order: AdminMallOrder) {
  return order.trackItems || []
}

async function onCloseTracking() {
  closeTracking()
  await reload()
  await refreshExpanded()
}

function openTrackingFromOrder(order: AdminMallOrder) {
  const first = trackItemsOf(order)[0]
  if (!first) return
  openTracking({
    idx: first.idx,
    courier: first.courier,
    invoice: first.invoice,
    name: first.name,
    orderCode: order.code,
  })
}
const cancelReason = ref('')
/*
 * 초기값을 true 로 둔다. onMounted 의 reload() 가 시작되기 전 짧은 순간에
 * displayOrders.length === 0 & loading=false 조합이 렌더링되면
 * 「조건에 맞는 주문이 없습니다.」 가 잠깐 번쩍이며 사용자가 주문번호 딥링크로
 * 넘어왔는데도 「없음」 상태로 오해할 수 있다. reload가 실패하면 즉시 false 로 내려간다.
 */
const loading = ref(true)
const errorMessage = ref('')
const working = ref('')
const adminMemoDraft = ref('')
const memoBusy = ref(false)

function normalizeSectionParam(
  raw: string,
  notifiedRaw = String(route.query.notified ?? ''),
): OrderSectionKey | '' {
  const notified = notifiedRaw === '1'
  const upper = raw.toUpperCase()
  if (upper === 'PENDING') return notified ? 'notified' : 'unnotified'
  if (upper === 'PAID') return 'shipping'
  if (upper === 'CANCELED') return 'canceled'
  const lower = raw.toLowerCase()
  if (lower === 'new') return 'shipping'
  if (lower === 'refund') return ''
  if (lower === 'unpaid') return notified ? 'notified' : 'unnotified'
  if (['notified', 'unnotified', 'shipping', 'done', 'canceled'].includes(lower)) {
    return lower as OrderSectionKey
  }
  return ''
}

function readWorkFromQuery(
  workRaw = String(route.query.work ?? ''),
  sectionRaw = String(route.query.section ?? ''),
): WorkFilterKey | '' {
  const fromWork = workRaw.toLowerCase()
  if (fromWork === 'refund' || fromWork === 'claim') return fromWork
  if (sectionRaw.toLowerCase() === 'refund') return 'refund'
  return ''
}

const taxOnly = ref(String(route.query.tax ?? '') === '1')
const work = ref<WorkFilterKey | ''>(taxOnly.value ? '' : readWorkFromQuery())
const status = ref<OrderSectionKey | ''>(
  taxOnly.value || work.value
    ? ''
    : normalizeSectionParam(
        String(route.query.section ?? route.query.status ?? ''),
        String(route.query.notified ?? ''),
      ),
)
const keyword = ref(String(route.query.keyword ?? ''))

/*
 * keywordFocusCode 는 displayOrders 를 참조하므로, 그 정의가 뒤에 있는
 * 지금 이 자리에서 computed 를 만들면 `watch(keywordFocusCode, …)` 등록 시점에
 * baseline 을 잡느라 getter 가 즉시 한 번 호출되면서 TDZ(ReferenceError:
 * "Cannot access 'displayOrders' before initialization") 로 setup 이 통째로
 * 중단된다 (컴포넌트가 「<!---->」 로만 렌더되어 화면이 텅 빈다).
 * 그래서 keywordFocusCode 와 그 감시자는 displayOrders 정의 이후로 옮겨 둔다.
 */

const taxPendingCount = computed(() => counts.value.taxInvoicePending ?? 0)

function taxLabelOf(order: AdminMallOrder): string {
  return MALL_TAX_STATUS_LABEL[effectiveTaxStatus(order)] || '미요청'
}

function effectiveTaxStatus(order: AdminMallOrder): string {
  return order.taxStatus || (order.taxInvoice ? 'REQUESTED' : 'NONE')
}

function taxDisplayEmail(order: AdminMallOrder): string {
  return String(order.taxEmail || order.memberEmail || '').trim()
}

function taxDisplayBizCert(order: AdminMallOrder): string {
  return String(order.bizCert || order.memberBizCert || '').trim()
}

function taxIssuesOf(order: AdminMallOrder): string[] {
  return listTaxInvoiceIssues({
    bizName: order.bizName,
    bizNum: order.bizNum,
    taxEmail: order.taxEmail,
    bizCert: order.bizCert,
  })
}

function canCancelOrder(order: AdminMallOrder): boolean {
  return !orderHasDelivered(order)
}

const taxRejectIssues = computed(() => {
  if (!taxRejectTarget.value) return [] as string[]
  const issues = [...taxIssuesOf(taxRejectTarget.value)]
  const extra = taxRejectExtra.value.trim()
  if (extra) issues.push(extra)
  return issues
})

watch(taxRejectIssues, (issues) => {
  if (!taxRejectTarget.value) return
  taxRejectSms.value = buildTaxRejectSms(taxRejectTarget.value.code, issues)
})

function taxToneOf(order: AdminMallOrder): string {
  const status = effectiveTaxStatus(order)
  if (status === 'DONE') return 'sui-badge--green'
  if (status === 'REQUESTED') return 'sui-badge--violet'
  return 'sui-badge--gray'
}

function patchOrderInList(order: AdminMallOrder) {
  const index = orders.value.findIndex((row) => row.code === order.code)
  if (index >= 0) {
    orders.value[index] = { ...orders.value[index], ...order }
  }
}

async function onTaxComplete(order: AdminMallOrder) {
  const ok = await confirmDialog({
    title: '세금계산서 발행 완료',
    message: `${order.code} 주문의 세금계산서 발행을 완료 처리할까요?`,
    confirmLabel: '발행 완료',
  })
  if (!ok) return

  working.value = order.code
  try {
    const result = await saveAdminTaxStatus(order.code, 'DONE', {
      bizNum: order.bizNum,
      bizName: order.bizName,
    })
    notify('세금계산서 발행을 완료 처리했습니다.')
    patchOrderInList(result.order)
    if (taxTarget.value?.code === order.code) {
      if (taxOnly.value) {
        closeTaxModal()
      } else {
        taxTarget.value = result.order
      }
    }
    await reload()
  } catch (error) {
    notify(error instanceof Error ? error.message : '세금계산서 상태를 저장하지 못했습니다.')
  } finally {
    working.value = ''
  }
}

async function onTaxUndo(order: AdminMallOrder) {
  const ok = await confirmDialog({
    title: '발행 완료 취소',
    message: `${order.code} 주문의 세금계산서 발행 완료를 취소하고 발행 요청 상태로 되돌릴까요?`,
    confirmLabel: '완료 취소',
    tone: 'danger',
  })
  if (!ok) return

  working.value = order.code
  try {
    const result = await saveAdminTaxStatus(order.code, 'REQUESTED', {
      bizNum: order.bizNum,
      bizName: order.bizName,
    })
    notify('발행 완료를 취소했습니다.')
    patchOrderInList(result.order)
    if (taxTarget.value?.code === order.code) {
      taxTarget.value = result.order
    }
    await reload()
  } catch (error) {
    notify(error instanceof Error ? error.message : '세금계산서 상태를 저장하지 못했습니다.')
  } finally {
    working.value = ''
  }
}

async function openTaxModal(order: AdminMallOrder) {
  taxTarget.value = order
  taxLoading.value = true
  try {
    taxTarget.value = await fetchAdminOrder(order.code)
  } catch (error) {
    notify(error instanceof Error ? error.message : '세금계산서 정보를 불러오지 못했습니다.')
  } finally {
    taxLoading.value = false
  }
}

function closeTaxModal() {
  taxTarget.value = null
  taxLoading.value = false
}

function openDetailFromTax() {
  const code = taxTarget.value?.code
  closeTaxModal()
  if (!code) return
  const order =
    displayOrders.value.find((row) => row.code === code)
    || orders.value.find((row) => row.code === code)
  if (order) void expandOrder(order, { scroll: true })
}

function openTaxReject(order: AdminMallOrder) {
  taxRejectTarget.value = order
  taxRejectExtra.value = ''
  taxRejectSendSms.value = Boolean(order.phone)
  const issues = taxIssuesOf(order)
  taxRejectSms.value = buildTaxRejectSms(order.code, issues)
}

function closeTaxReject() {
  taxRejectTarget.value = null
  taxRejectExtra.value = ''
  taxRejectSms.value = ''
}

async function submitTaxReject() {
  if (!taxRejectTarget.value || working.value) return
  const issues = taxRejectIssues.value
  if (!issues.length) {
    notify('반려 사유를 입력해 주세요.')
    return
  }

  const ok = await confirmDialog({
    title: '발행 요청 반려',
    message: `${taxRejectTarget.value.code} 세금계산서 발행 요청을 반려할까요?`,
    detail: taxRejectSendSms.value
      ? `아래 내용으로 문자를 보냅니다.\n\n${taxRejectSms.value}`
      : '문자는 보내지 않습니다.',
    confirmLabel: '반려',
    tone: 'danger',
  })
  if (!ok) return

  working.value = taxRejectTarget.value.code
  try {
    const result = await rejectAdminTaxInvoice(taxRejectTarget.value.code, {
      issues,
      smsMessage: taxRejectSms.value,
      sendSms: taxRejectSendSms.value,
    })
    notify(result.message || '세금계산서 발행 요청을 반려했습니다.')
    patchOrderInList(result.order)
    closeTaxReject()
    closeTaxModal()
    await reload()
  } catch (error) {
    notify(error instanceof Error ? error.message : '세금계산서 발행 요청을 반려하지 못했습니다.')
  } finally {
    working.value = ''
  }
}

const ITEM_TONE: Record<MallOrderItemStatus, string> = {
  WAITING: 'sui-badge--gray',
  PAID: 'sui-badge--blue',
  READY: 'sui-badge--violet',
  SHIPPING: 'sui-badge--amber',
  DELIVERED: 'sui-badge--green',
  DONE: 'sui-badge--green',
  CANCEL_REQUEST: 'sui-badge--red',
  RETURN_REQUEST: 'sui-badge--red',
  CANCELED: 'sui-badge--gray',
}

const ITEM_FLOW: MallOrderItemStatus[] = ['PAID', 'READY', 'SHIPPING', 'DELIVERED', 'DONE']

const fulfillSteps = [
  { key: 'confirm' as const, label: '결제 확인' },
  { key: 'ready' as const, label: '업체 확인' },
  { key: 'ship' as const, label: '발송' },
  { key: 'deliver' as const, label: '배송완료' },
]

function itemTone(value: MallOrderItemStatus): string {
  return ITEM_TONE[value] ?? 'sui-badge--gray'
}

/** 이 화면은 배송 여부만 본다. 구매확정은 배송완료와 같이 표시한다. */
function itemStatusLabel(value: MallOrderItemStatus): string {
  if (value === 'DONE') return MALL_ORDER_ITEM_STATUS_LABEL.DELIVERED
  return MALL_ORDER_ITEM_STATUS_LABEL[value]
}

function orderItemStatuses(order: AdminMallOrder): MallOrderItemStatus[] {
  return (order.items?.map((item) => item.status) ?? order.itemStatuses ?? []) as MallOrderItemStatus[]
}

function refundCountsOf(order: AdminMallOrder) {
  const fromItems = order.items || []
  const pendingFromItems = fromItems.filter((item) => item.refundStatus === 'PENDING').length
  const doneFromItems = fromItems.filter((item) => item.refundStatus === 'DONE').length
  return {
    pending: Math.max(Number(order.refundPendingCount) || 0, pendingFromItems),
    done: Math.max(Number(order.refundDoneCount) || 0, doneFromItems),
  }
}

function refundSummaryOf(order: AdminMallOrder | null | undefined) {
  if (!order) return null
  const { pending, done } = refundCountsOf(order)
  if (pending > 0) {
    // 환불 대기는 「승인된 취소·반품 → 송금 필요」 상태로 가장 긴급하다.
    // 총 환불 금액을 함께 표시해서 담당자가 규모를 즉시 파악할 수 있게 한다.
    const pendingAmount = (order.items || [])
      .filter((item) => item.refundStatus === 'PENDING')
      .reduce((sum, item) => sum + (Number(item.refundAmount) || Number(item.amount) || 0), 0)
    const countLabel = pending > 1 ? ` ${pending}건` : ''
    const amountLabel = pendingAmount > 0 ? ` · ${formatWon(pendingAmount)}원` : ''
    return {
      label: `환불 대기${countLabel}${amountLabel}`,
      tone: 'aord__refund-chip--strong',
      status: 'PENDING' as const,
    }
  }
  if (done > 0) {
    return {
      label: done > 1 ? `환불 완료 ${done}` : '환불 완료',
      tone: 'aord__refund-chip--done',
      status: 'DONE' as const,
    }
  }
  return null
}

/** 입금 전에 취소되어 돌려줄 돈이 없는 주문 */
function isUnpaidCancel(order: AdminMallOrder) {
  if (order.status !== 'CANCELED' || order.paidAt) return false
  const { pending, done } = refundCountsOf(order)
  return pending === 0 && done === 0
}

function activeClaimLabel(order: AdminMallOrder): string {
  const statuses = orderItemStatuses(order)
  const hasCancel = statuses.includes('CANCEL_REQUEST')
  const hasReturn = statuses.includes('RETURN_REQUEST')
  if (hasCancel && hasReturn) return '취소·반품 대기'
  if (hasCancel) return '취소 대기'
  if (hasReturn) return '반품 대기'
  return '처리 대기'
}

function progressOf(order: AdminMallOrder) {
  const statuses = orderItemStatuses(order)
  const hasClaim = statuses.some(
    (itemStatus) => itemStatus === 'CANCEL_REQUEST' || itemStatus === 'RETURN_REQUEST',
  )
  const canceledItems = statuses.filter((itemStatus) => itemStatus === 'CANCELED').length
  const activeItems = statuses.filter((itemStatus) => itemStatus !== 'CANCELED').length

  if (order.status === 'CANCELED' || (statuses.length > 0 && activeItems === 0)) {
    return {
      title: '주문 취소',
      tone: 'sui-badge--gray',
      hint: isUnpaidCancel(order)
        ? order.payMethod === 'TOSS'
          ? '결제 전에 취소되어 환불이 없습니다.'
          : '입금 전에 취소되어 환불이 없습니다.'
        : '이 주문은 취소되었습니다.',
    }
  }
  if (canceledItems > 0 && activeItems > 0) {
    return {
      title: '부분 취소',
      tone: 'sui-badge--red',
      hint: `상품 ${canceledItems}건이 취소되었습니다.`,
    }
  }
  if (order.status === 'PENDING' && order.payMethod === 'TOSS') {
    return { title: '결제 대기', tone: 'sui-badge--amber', hint: '구매자가 카드·간편결제를 아직 마치지 않았습니다.' }
  }
  if (order.status === 'PENDING' && order.payNotifiedAt) {
    return { title: '입금 알림', tone: 'sui-badge--violet', hint: '구매 기관이 입금했다고 알렸습니다. 통장을 확인해 주세요.' }
  }
  if (order.status === 'PENDING') {
    return { title: '입금 미진행', tone: 'sui-badge--amber', hint: '아직 「입금했어요」를 누르지 않았습니다.' }
  }
  if (hasClaim) {
    const claim = statuses.find(
      (itemStatus) => itemStatus === 'CANCEL_REQUEST' || itemStatus === 'RETURN_REQUEST',
    )
    return {
      title: claim === 'RETURN_REQUEST' ? '반품 요청' : '취소 요청',
      tone: 'sui-badge--red',
      hint: '클레임이 진행 중입니다.',
    }
  }

  const furthest = furthestItemStatus(order)
  if (furthest === 'READY') {
    return { title: '발송 준비', tone: itemTone('READY'), hint: '업체가 주문을 확인했습니다. 발송 전입니다.' }
  }
  if (furthest === 'SHIPPING') {
    return { title: '배송중', tone: itemTone('SHIPPING'), hint: '업체가 발송했습니다. 도착하면 자동으로 배송완료됩니다.' }
  }
  if (furthest === 'DELIVERED' || furthest === 'DONE') {
    return { title: '배송완료', tone: itemTone('DELIVERED'), hint: '배송이 완료되었습니다.' }
  }
  return { title: '업체 미확인', tone: itemTone('PAID'), hint: '결제확인됨 · 판매업체가 아직 주문 확인 전입니다.' }
}

function furthestItemStatus(order: AdminMallOrder): MallOrderItemStatus | '' {
  let best = -1
  let value: MallOrderItemStatus | '' = ''
  orderItemStatuses(order).forEach((itemStatus) => {
    const index = ITEM_FLOW.indexOf(itemStatus)
    if (index > best) {
      best = index
      value = itemStatus
    }
  })
  return value
}

function stepState(
  order: AdminMallOrder,
  step: 'confirm' | 'ready' | 'ship' | 'deliver',
) {
  if (order.status === 'CANCELED') {
    return ''
  }
  if (order.status === 'PENDING') {
    return step === 'confirm' ? 'current' : ''
  }
  const furthest = furthestItemStatus(order)
  const index = ITEM_FLOW.indexOf(furthest)
  if (step === 'confirm') return 'done'
  if (step === 'ready') {
    if (index >= 1) return 'done'
    if (index === 0) return 'current'
    return ''
  }
  if (step === 'ship') {
    if (index >= 2) return 'done'
    if (index === 1) return 'current'
    return ''
  }
  if (index >= 3) return 'done'
  if (index === 2) return 'current'
  return ''
}

function canUnconfirm(order: AdminMallOrder): boolean {
  if (order.status !== 'PAID' || order.payMethod === 'TOSS') return false
  const statuses = order.items?.map((item) => item.status) ?? order.itemStatuses ?? []
  if (!statuses.length) return true
  return statuses.every((status) => status === 'PAID' || status === 'WAITING')
}

function hasActiveClaim(order: AdminMallOrder) {
  return orderItemStatuses(order).some(
    (itemStatus) => itemStatus === 'CANCEL_REQUEST' || itemStatus === 'RETURN_REQUEST',
  )
}
function qnaOpenCountOf(order: AdminMallOrder) {
  return Math.max(Number(order.qnaOpenCount) || 0, order.openQnas?.length || 0)
}
function openQnasOf(order: AdminMallOrder) {
  return order.openQnas || []
}
/** 취소·반품 대기이거나 미답변 상품문의가 있으면 클레임·문의 조건에 넣는다. */
function hasClaimWork(order: AdminMallOrder) {
  return hasActiveClaim(order) || qnaOpenCountOf(order) > 0
}

/**
 * 상단 주문 상태 pill과 아래 섹션을 일대일 매핑한다.
 * counts는 서버 status 기준이 아니라, 클라이언트에서 sectionKeyOf로 실제 분류한 결과다.
 */
const sectionCounts = computed<Record<OrderSectionKey, number>>(() => {
  const buckets: Record<OrderSectionKey, number> = {
    notified: 0,
    unnotified: 0,
    shipping: 0,
    done: 0,
    canceled: 0,
  }
  orders.value.forEach((order) => {
    buckets[sectionKeyOf(order)] += 1
  })
  return buckets
})

const workCounts = computed(() => {
  let refund = 0
  let claim = 0
  orders.value.forEach((order) => {
    if (refundCountsOf(order).pending > 0) refund += 1
    if (hasClaimWork(order)) claim += 1
  })
  return { refund, claim }
})

const statusTabs = computed(() => {
  const total = orders.value.length
  return [
    { key: '' as OrderSectionKey | '', label: '전체', count: total, tone: '' as const },
    ...ORDER_SECTION_META.map((meta) => ({
      key: meta.key as OrderSectionKey | '',
      label: meta.title,
      count: sectionCounts.value[meta.key],
      tone: meta.tone,
    })),
  ]
})

const workTabs = computed(() => [
  {
    key: 'refund' as const,
    label: '환불 대기',
    count: workCounts.value.refund,
    tone: 'red' as const,
  },
  {
    key: 'claim' as const,
    label: '클레임 · 문의',
    count: workCounts.value.claim,
    tone: 'amber' as const,
  },
])

const displayOrders = computed(() => {
  let rows = orders.value
  if (work.value === 'refund') {
    rows = rows.filter((order) => refundCountsOf(order).pending > 0)
  } else if (work.value === 'claim') {
    rows = rows.filter((order) => hasClaimWork(order))
  } else if (status.value) {
    rows = rows.filter((order) => sectionKeyOf(order) === status.value)
  }
  return rows
})

/*
 * keyword 로 정확히 한 건이 걸리면 그 코드를 반환해, 「검색된 주문」 뱃지·자동 확장의 힌트로 쓴다.
 * 이 computed 와 아래 watch 는 displayOrders 뒤에 정의해야 한다.
 * (앞에 두면 watch 등록 시 baseline 을 위해 getter 를 한 번 호출하는데
 *  그때 displayOrders 가 아직 TDZ 라 setup 전체가 죽는다.)
 */
const keywordFocusCode = computed(() => {
  const code = keyword.value.trim()
  if (!code) return ''
  const matched = displayOrders.value.filter((order) => order.code === code)
  return matched.length === 1 ? code : ''
})

// 주문번호로 정확히 1건 검색된 경우 자동으로 상세 확장 + 카드 스크롤
// (다른 페이지에서 keyword 파라미터로 넘어왔을 때 즉시 상세가 보이도록 통일)
watch(keywordFocusCode, (code) => {
  if (!code) return
  const order = displayOrders.value.find((o) => o.code === code)
  if (!order) return
  if (expandedCode.value === code) {
    // 이미 열려 있어도 스크롤은 다시 맞춰 준다 (긴 목록에서 놓칠 수 있으므로)
    void nextTick().then(() => {
      document.getElementById(`aord-detail-${code}`)?.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      })
    })
    return
  }
  void expandOrder(order, { scroll: true })
})

/**
 * 주문을 생명주기 중 하나로만 분류한다.
 * 입금 전은 「입금했어요」 여부로 입금 알림 / 입금 미진행을 나눈다.
 */
function sectionKeyOf(order: AdminMallOrder): OrderSectionKey {
  if (order.status === 'CANCELED') return 'canceled'
  if (order.status === 'PENDING') return order.payNotifiedAt ? 'notified' : 'unnotified'
  const furthest = furthestItemStatus(order)
  if (furthest === 'DELIVERED' || furthest === 'DONE') return 'done'
  return 'shipping'
}

const ORDER_SECTION_META: OrderSectionMeta[] = [
  {
    key: 'notified',
    title: '입금 알림',
    desc: '구매 기관이 「입금했어요」를 눌렀습니다. 통장을 확인해 주세요',
    icon: 'mdi-bell-ring-outline',
    tone: 'violet',
  },
  {
    key: 'unnotified',
    title: '결제 전',
    desc: '토스페이먼츠 결제 전입니다. 이전 계좌이체 주문은 「입금했어요」 전입니다',
    icon: 'mdi-cash-clock',
    tone: 'amber',
  },
  {
    key: 'shipping',
    title: '배송 진행',
    desc: '결제확인 완료 · 업체 미확인 · 발송 준비 · 배송중',
    icon: 'mdi-truck-delivery-outline',
    tone: 'blue',
  },
  {
    key: 'done',
    title: '완료',
    desc: '배송완료 · 참조용',
    icon: 'mdi-check-all',
    tone: 'gray',
  },
  {
    key: 'canceled',
    title: '취소',
    desc: '주문 취소 · 결제확인 이전 자동 취소 · 참조용',
    icon: 'mdi-close-circle-outline',
    tone: 'slate',
  },
]

const orderSections = computed(() => {
  const buckets: Record<OrderSectionKey, AdminMallOrder[]> = {
    notified: [],
    unnotified: [],
    shipping: [],
    done: [],
    canceled: [],
  }
  displayOrders.value.forEach((order) => {
    buckets[sectionKeyOf(order)].push(order)
  })
  return ORDER_SECTION_META.map((meta) => ({
    ...meta,
    orders: buckets[meta.key],
  })).filter((section) => section.orders.length > 0)
})

function syncQuery() {
  const query: Record<string, string> = {}
  if (taxOnly.value) {
    query.tax = '1'
  } else if (work.value) {
    query.work = work.value
  } else if (status.value) {
    query.section = status.value
  }
  if (keyword.value.trim()) query.keyword = keyword.value.trim()
  router.replace({ path: '/admin/orders', query })
}

function clearKeyword() {
  keyword.value = ''
  syncQuery()
  void reload()
}

async function reload() {
  loading.value = true
  errorMessage.value = ''

  try {
    // 서버 status 필터는 사용하지 않는다. 상단 pill은 아래 섹션과 매칭되는
    // 클라이언트 분류(sectionKeyOf) 기준이므로, 서버는 항상 전체를 내려주고
    // pill 클릭은 displayOrders에서 필터한다. counts도 클라이언트에서 재집계한다.
    const result = await fetchAdminOrders({
      keyword: keyword.value,
      from: fromDate.value,
      to: toDate.value,
      tax: taxOnly.value,
    })
    orders.value = result.orders
    counts.value = result.counts
    await refreshExpanded()
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '주문을 불러오지 못했습니다.'
    orders.value = []
  } finally {
    loading.value = false
  }
}

function setStatus(next: OrderSectionKey | '') {
  taxOnly.value = false
  work.value = ''
  status.value = next
  syncQuery()
  void reload()
}

function setWork(next: WorkFilterKey) {
  taxOnly.value = false
  work.value = next
  status.value = ''
  syncQuery()
  void reload()
}

function setTaxOnly(active: boolean) {
  taxOnly.value = active
  if (active) {
    status.value = ''
    work.value = ''
  }
  syncQuery()
  void reload()
}

function onPreset(key: DatePresetKey) {
  applyPreset(key)
  void reload()
}

function onDateChange() {
  onManualDateChange()
  void reload()
}

function downloadCsv() {
  const rows = displayOrders.value
  if (!rows.length) return
  const header = taxOnly.value
    ? [
        '주문번호',
        '주문일시',
        '회원명',
        '입금자',
        '상호',
        '사업자번호',
        '수신이메일',
        '사업자등록증',
        '입금액',
      ]
    : [
        '주문번호',
        '결제수단',
        '주문일시',
        '처리현황',
        '회원명',
        '수령인',
        '연락처',
        '입금자',
        '상품요약',
        '상품수',
        '상품금액',
        '배송비',
        '결제금액',
        '세금계산서',
        '발행완료일시',
        '입금알림',
        '결제확인일시',
      ]
  const body = rows.map((order) => {
    const cells = taxOnly.value
      ? [
          order.code,
          order.orderedAt || '',
          order.orgName || '',
          order.depositor || '',
          order.bizName || '',
          order.bizNum || '',
          order.taxEmail || '',
          order.bizCert ? bizCertHref(order.bizCert) : '',
          order.totalAmount,
        ]
      : [
          order.code,
          mallPayMethodLabel(order),
          order.orderedAt || '',
          progressOf(order).title,
          order.orgName || '',
          order.receiver || '',
          order.phone || '',
          order.depositor || '',
          order.itemSummary || '',
          order.itemCount,
          order.itemAmount,
          order.shippingFee,
          order.totalAmount,
          taxLabelOf(order),
          effectiveTaxStatus(order) === 'DONE' && order.taxAt ? order.taxAt : '',
          order.payNotifiedAt || '',
          order.paidAt || '',
        ]
    return cells.map((cell) => csvEscape(cell)).join(',')
  })
  const csv = `\uFEFF${[header.join(','), ...body].join('\n')}`
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = `관리자주문_${new Date().toISOString().slice(0, 10)}.csv`
  anchor.click()
  URL.revokeObjectURL(url)
}

onMounted(async () => {
  await reload()
  try {
    payment.value = await fetchPaymentInfo()
  } catch {
    payment.value = null
  }
})

watch(
  () => [
    route.query.section,
    route.query.status,
    route.query.work,
    route.query.notified,
    route.query.tax,
    route.query.keyword,
  ],
  () => {
    const nextTax = String(route.query.tax ?? '') === '1'
    const nextWork = nextTax
      ? ''
      : readWorkFromQuery(String(route.query.work ?? ''), String(route.query.section ?? ''))
    const nextStatus =
      nextTax || nextWork
        ? ''
        : normalizeSectionParam(
            String(route.query.section ?? route.query.status ?? ''),
            String(route.query.notified ?? ''),
          )
    const nextKeyword = String(route.query.keyword ?? '')
    let changed = false
    if (nextTax !== taxOnly.value) {
      taxOnly.value = nextTax
      changed = true
    }
    if (nextWork !== work.value) {
      work.value = nextWork
      changed = true
    }
    if (nextStatus !== status.value) {
      status.value = nextStatus
      changed = true
    }
    if (nextKeyword !== keyword.value) {
      keyword.value = nextKeyword
      changed = true
      /*
       * CS·정산 등에서 「관련 주문」 링크로 다시 넘어올 때는 이미 열려 있던
       * 주문 페이지 인스턴스를 재사용하므로 setup은 재실행되지 않는다.
       * 그동안 사용자가 좁혀 둔 기간 필터에 가려 검색 결과가 비지 않도록,
       * keyword 만 있고 preset이 명시되지 않았으면 「전체」로 다시 넓혀 준다.
       */
      expandRangeForDeepLink()
    }
    if (changed) void reload()
  },
)

async function expandOrder(order: AdminMallOrder, opts?: { scroll?: boolean }) {
  const alreadyOpen =
    expandedCode.value === order.code && (expandedDetail.value || expandedLoading.value)
  if (!alreadyOpen) {
    expandedCode.value = order.code
    expandedDetail.value = null
    expandedError.value = ''
    expandedLoading.value = true
    try {
      const loaded = await fetchAdminOrder(order.code)
      if (expandedCode.value !== order.code) return
      expandedDetail.value = loaded
      adminMemoDraft.value = loaded.adminMemo || ''
    } catch (error) {
      if (expandedCode.value === order.code) {
        expandedError.value = error instanceof Error ? error.message : '주문을 불러오지 못했습니다.'
      }
    } finally {
      if (expandedCode.value === order.code) expandedLoading.value = false
    }
  }
  if (!opts?.scroll) return
  await nextTick()
  document.getElementById(`aord-detail-${order.code}`)?.scrollIntoView({
    block: 'center',
    behavior: 'smooth',
  })
}

async function toggleExpand(order: AdminMallOrder) {
  if (expandedCode.value === order.code) {
    closeExpand()
    return
  }
  await expandOrder(order)
}

function closeExpand() {
  expandedCode.value = ''
  expandedDetail.value = null
  expandedError.value = ''
}

async function refreshExpanded() {
  if (!expandedCode.value) return
  const code = expandedCode.value
  try {
    const loaded = await fetchAdminOrder(code)
    if (expandedCode.value !== code) return
    expandedDetail.value = loaded
    adminMemoDraft.value = loaded.adminMemo || ''
  } catch {
    // 조용히 실패 (목록은 이미 reload됨)
  }
}

async function saveMemo() {
  const active = expandedDetail.value
  if (!active || memoBusy.value) return
  if (!window.confirm('내부 메모를 저장할까요?')) return
  memoBusy.value = true
  try {
    const result = await saveAdminOrderMemo(active.code, adminMemoDraft.value)
    if (expandedDetail.value?.code === active.code) expandedDetail.value = result.order
    adminMemoDraft.value = result.order.adminMemo || ''
    notify('내부 메모를 저장했습니다.')
  } catch (error) {
    notify(error instanceof Error ? error.message : '메모를 저장하지 못했습니다.')
  } finally {
    memoBusy.value = false
  }
}

const expandedPlatformMargin = computed(() =>
  (expandedDetail.value?.items ?? []).reduce((sum, item) => sum + item.platformMargin, 0),
)

const expandedRefund = computed(() => {
  const order = expandedDetail.value
  const totals = mallOrderRefundTotals(order?.items ?? [])
  const charged = Math.max(0, Number(order?.totalAmount) || 0)
  return {
    ...totals,
    balance: Math.max(0, charged - totals.refunded),
  }
})

// 확장된 주문의 상품을 판매업체별로 그룹핑
const expandedSellerGroups = computed(() => {
  const items = expandedDetail.value?.items ?? []
  const map = new Map<string, typeof items>()
  for (const item of items) {
    const key = item.storeName || '판매업체 미지정'
    const arr = map.get(key) ?? []
    arr.push(item)
    map.set(key, arr)
  }
  return Array.from(map.entries()).map(([storeName, storeItems]) => {
    const amount = storeItems.reduce((sum, item) => sum + item.amount, 0)
    return { storeName, items: storeItems, amount }
  })
})

async function onConfirm(order: AdminMallOrder) {
  if (working.value) return

  const ok = await confirmDialog({
    title: '입금 확인',
    message: '통장에서 입금을 확인하셨나요? 확인하면 판매업체에 주문이 전달되고 안내 메일·문자가 갑니다.',
    detail: [
      order.code,
      order.orgName || order.depositor || '',
      `입금액 ${formatWon(order.totalAmount)}원`,
      order.depositor ? `입금자 ${order.depositor}` : '',
    ]
      .filter(Boolean)
      .join('\n'),
    confirmLabel: '입금 확인',
    tone: 'primary',
  })
  if (!ok) return

  working.value = order.code

  try {
    const { message } = await confirmOrderPayment(order.code)
    notify(message || '결제확인 처리했습니다.')
    await reload()
    if (expandedCode.value === order.code) await refreshExpanded()
  } catch (error) {
    notify(error instanceof Error ? error.message : '결제확인에 실패했습니다.')
  } finally {
    working.value = ''
  }
}

async function onUnconfirm(order: AdminMallOrder) {
  if (working.value) return

  const ok = await confirmDialog({
    title: '결제확인 취소',
    message:
      '주문을 끝내는 것이 아닙니다. 결제확인만 취소하고 입금 대기로 되돌립니다. 나중에 다시 결제확인할 수 있습니다. 판매업체 목록에서 주문이 사라지고 재고가 복구됩니다. 주문을 아예 끝내려면 「주문 취소」를 누르세요.',
    detail: [
      order.code,
      order.orgName || order.depositor || '',
      `입금액 ${formatWon(order.totalAmount)}원`,
    ]
      .filter(Boolean)
      .join('\n'),
    confirmLabel: '입금대기로 되돌리기',
    tone: 'danger',
  })
  if (!ok) return

  working.value = order.code

  try {
    const { message } = await unconfirmOrderPayment(order.code)
    notify(message || '결제확인을 취소했습니다.')
    await reload()
    if (expandedCode.value === order.code) await refreshExpanded()
  } catch (error) {
    notify(error instanceof Error ? error.message : '결제확인 취소에 실패했습니다.')
  } finally {
    working.value = ''
  }
}

function onCancel(order: AdminMallOrder) {
  cancelTarget.value = order
  cancelReason.value = ''
}

function closeCancel() {
  cancelTarget.value = null
  cancelReason.value = ''
}

async function submitCancel() {
  if (!cancelTarget.value || !cancelReason.value || working.value) return
  const ok = await confirmDialog({
    title: '주문 취소',
    message:
      cancelTarget.value.payMethod === 'TOSS' && cancelTarget.value.status === 'PAID'
        ? '이 주문을 끝냅니다. 다시 살릴 수 없습니다. 결제된 금액은 카드·간편결제로 환불됩니다.'
        : '이 주문을 끝냅니다. 다시 살릴 수 없습니다. 입금 확인만 되돌리려면 창을 닫고 「결제확인 취소」를 누르세요.',
    detail: `${cancelTarget.value.code}\n사유: ${cancelReason.value}`,
    confirmLabel: '주문 취소 확정',
    tone: 'danger',
  })
  if (!ok) return

  working.value = cancelTarget.value.code
  const canceledCode = cancelTarget.value.code
  try {
    await cancelOrderByAdmin(cancelTarget.value.code, cancelReason.value)
    notify('주문을 취소했습니다.')
    closeCancel()
    await reload()
    if (expandedCode.value === canceledCode) await refreshExpanded()
  } catch (error) {
    notify(error instanceof Error ? error.message : '주문을 취소하지 못했습니다.')
  } finally {
    working.value = ''
  }
}

const API_ORIGIN = (process.env.VUE_APP_API_ORIGIN || '').replace(/\/$/, '')

function taxStatusLabel(status?: string) {
  return MALL_TAX_STATUS_LABEL[String(status || '').toUpperCase()] || '미요청'
}

function bizCertHref(path: string) {
  return path.startsWith('http') ? path : `${API_ORIGIN}${path}`
}

function taxDocHref(path: string) {
  return path.startsWith('http') ? path : `${API_ORIGIN}${path}`
}

function formatDateTime(value: string | null): string {
  if (!value) return '-'
  const date = new Date(value)
  return `${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')} ${String(
    date.getHours(),
  ).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
}

function formatOrgDate(value: string | null | undefined): string {
  if (!value) return '-'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '-'
  return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`
}

async function openOrgDetail(memberCode: string, fallbackName = '', orderCode = '') {
  const code = String(memberCode || '').trim()
  if (!code) return
  orgModalOpen.value = true
  orgLoading.value = true
  orgError.value = ''
  orgFocusOrderCode.value = String(orderCode || '').trim()
  orgDetail.value = fallbackName
    ? ({
        orgName: fallbackName,
        mCode: code,
        userId: '',
        bossName: '',
        bossPhone: '',
        bossEmail: '',
        discountPct: 0,
        taxRequests: [],
      } as AdminMemberRow)
    : null
  try {
    orgDetail.value = await fetchAdminMember(code)
  } catch (error: any) {
    orgError.value = error?.message || '회원 정보를 불러오지 못했습니다.'
  } finally {
    orgLoading.value = false
  }
}

function closeOrgDetail() {
  orgModalOpen.value = false
  orgLoading.value = false
  orgError.value = ''
  orgDetail.value = null
  orgFocusOrderCode.value = ''
}

function memberTaxTone(status?: string) {
  const key = String(status || '').toUpperCase()
  if (key === 'DONE') return 'sui-badge--green'
  if (key === 'REJECTED') return 'sui-badge--red'
  if (key === 'REQUESTED') return 'sui-badge--amber'
  return 'sui-badge--gray'
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[39] || (_cache[39] = _createElementVNode("span", { class: "aord__filter-group-label" }, "주문 상태", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusTabs.value, (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              key: tab.key || 'all',
              type: "button",
              class: _normalizeClass(["aord__filter", [
              tab.tone ? `aord__filter--tone-${tab.tone}` : '',
              { 'is-active': !taxOnly.value && !work.value && status.value === tab.key },
            ]]),
              onClick: ($event: any) => (setStatus(tab.key))
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(tab.label), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(tab.count), 1)
            ], 10, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[41] || (_cache[41] = _createElementVNode("span", { class: "aord__filter-group-label" }, "처리할 일", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workTabs.value, (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              key: tab.key,
              type: "button",
              class: _normalizeClass(["aord__filter", [
              tab.tone ? `aord__filter--tone-${tab.tone}` : '',
              { 'is-active': !taxOnly.value && work.value === tab.key },
            ]]),
              onClick: ($event: any) => (setWork(tab.key))
            }, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(tab.label), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(tab.count), 1)
            ], 10, _hoisted_9))
          }), 128)),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["aord__filter aord__filter--tax", { 'is-active': taxOnly.value }]),
            "data-tour": "admin-orders-tax",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setTaxOnly(true)))
          }, [
            _cache[40] || (_cache[40] = _createElementVNode("span", { class: "aord__filter-label" }, "세금계산서", -1)),
            _createElementVNode("span", _hoisted_12, _toDisplayString(taxPendingCount.value), 1)
          ], 2)
        ]),
        _cache[42] || (_cache[42] = _createElementVNode("span", { class: "aord__filters-spacer" }, null, -1)),
        _createVNode(_component_router_link, {
          to: "/admin/settings",
          class: "aord__account-mini",
          "data-tour": "admin-orders-account",
          title: "입금 계좌 설정으로 이동"
        }, {
          default: _withCtx(() => [
            _createVNode(AppIcon, {
              icon: "mdi-bank-outline",
              size: 16
            }),
            _createElementVNode("span", _hoisted_13, [
              _createElementVNode("strong", null, _toDisplayString(payment.value?.bankName || '입금 계좌 미등록') + " " + _toDisplayString(payment.value?.account || ''), 1),
              _createElementVNode("em", null, _toDisplayString(payment.value?.holder || '계좌를 등록해 주세요'), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(presets), (item) => {
            return (_openBlock(), _createElementBlock("button", {
              key: item.key,
              type: "button",
              class: _normalizeClass({ 'is-active': _unref(preset) === item.key }),
              onClick: ($event: any) => (onPreset(item.key))
            }, _toDisplayString(item.label), 11, _hoisted_16))
          }), 128))
        ]),
        _createElementVNode("label", _hoisted_17, [
          _cache[43] || (_cache[43] = _createElementVNode("span", null, "시작일", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(fromDate) ? (fromDate).value = $event : null)),
            type: "date",
            onChange: onDateChange
          }, null, 544), [
            [_vModelText, _unref(fromDate)]
          ])
        ]),
        _createElementVNode("label", _hoisted_18, [
          _cache[44] || (_cache[44] = _createElementVNode("span", null, "종료일", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(toDate) ? (toDate).value = $event : null)),
            type: "date",
            onChange: onDateChange
          }, null, 544), [
            [_vModelText, _unref(toDate)]
          ])
        ]),
        _createElementVNode("label", _hoisted_19, [
          _createVNode(AppIcon, {
            icon: "mdi-magnify",
            size: 17
          }),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((keyword).value = $event)),
            type: "search",
            placeholder: "주문번호 · 입금자명 · 회원명 검색",
            onKeydown: _withKeys(reload, ["enter"])
          }, null, 544), [
            [
              _vModelText,
              keyword.value,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn",
          onClick: reload
        }, "검색"),
        _cache[47] || (_cache[47] = _createElementVNode("span", { class: "sui-toolbar__spacer" }, null, -1)),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn",
          disabled: !displayOrders.value.length,
          onClick: downloadCsv
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-download",
            size: 16
          }),
          _cache[45] || (_cache[45] = _createTextVNode(" CSV ", -1))
        ], 8, _hoisted_20),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn",
          disabled: loading.value,
          onClick: reload
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-refresh",
            size: 16
          }),
          _cache[46] || (_cache[46] = _createTextVNode(" 새로고침 ", -1))
        ], 8, _hoisted_21)
      ]),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
            _createVNode(AppIcon, {
              icon: "mdi-alert-outline",
              size: 16
            }),
            _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
          ]))
        : _createCommentVNode("", true),
      (taxOnly.value && displayOrders.value.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_23, " 「발행 요청」을 누르면 수신 이메일·사업자등록증을 확인하고 발행 완료 처리할 수 있습니다. "))
        : _createCommentVNode("", true),
      (displayOrders.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            (taxOnly.value)
              ? (_openBlock(), _createElementBlock("table", _hoisted_25, [
                  _cache[48] || (_cache[48] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "주문번호 · 일시"),
                      _createElementVNode("th", null, "회원 · 입금자"),
                      _createElementVNode("th", { class: "is-num" }, "입금액"),
                      _createElementVNode("th", { class: "is-center" }, "세금계산서")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayOrders.value, (order) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: order.code,
                        class: _normalizeClass({ 'is-focus': keywordFocusCode.value === order.code })
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_26, _toDisplayString(order.code), 1),
                          _createElementVNode("span", _hoisted_27, _toDisplayString(formatDateTime(order.orderedAt)), 1),
                          (keywordFocusCode.value === order.code)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, "검색된 주문"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          (order.memberCode && order.orgName)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "aord__org-btn",
                                onClick: ($event: any) => (openOrgDetail(order.memberCode, order.orgName, order.code))
                              }, _toDisplayString(order.orgName), 9, _hoisted_29))
                            : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(order.orgName || '-'), 1)),
                          _createElementVNode("span", _hoisted_31, _toDisplayString(order.depositor || order.receiver), 1)
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(formatWon)(order.totalAmount)) + "원", 1)
                        ]),
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["sui-badge aord__tax-chip", taxToneOf(order)]),
                            "data-tour": "admin-orders-tax-open",
                            onClick: ($event: any) => (openTaxModal(order))
                          }, _toDisplayString(taxLabelOf(order)), 11, _hoisted_35)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderSections.value, (section) => {
                    return (_openBlock(), _createElementBlock("section", {
                      key: section.key,
                      class: _normalizeClass(["aord__section", [`is-${section.key}`, `aord__section--tone-${section.tone}`]])
                    }, [
                      _createElementVNode("header", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, [
                          _createVNode(AppIcon, {
                            icon: section.icon,
                            size: 20
                          }, null, 8, ["icon"])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("h2", null, [
                            _createTextVNode(_toDisplayString(section.title) + " ", 1),
                            _createElementVNode("span", _hoisted_40, _toDisplayString(section.orders.length), 1)
                          ]),
                          _createElementVNode("p", null, _toDisplayString(section.desc), 1)
                        ])
                      ]),
                      (section.orders.length)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_41, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.orders, (order) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: order.code,
                                class: _normalizeClass(["aord__card", {
                  'is-focus': keywordFocusCode.value === order.code,
                  'is-expanded': expandedCode.value === order.code,
                }])
                              }, [
                                _createElementVNode("div", {
                                  class: "aord__card-summary",
                                  role: "button",
                                  tabindex: "0",
                                  "aria-expanded": expandedCode.value === order.code,
                                  "aria-controls": `aord-detail-${order.code}`,
                                  onClick: ($event: any) => (toggleExpand(order)),
                                  onKeydown: [
                                    _withKeys(_withModifiers(($event: any) => (toggleExpand(order)), ["prevent"]), ["enter"]),
                                    _withKeys(_withModifiers(($event: any) => (toggleExpand(order)), ["prevent"]), ["space"])
                                  ]
                                }, [
                                  _createElementVNode("header", _hoisted_43, [
                                    _createElementVNode("span", _hoisted_44, [
                                      _createVNode(AppIcon, {
                                        icon: expandedCode.value === order.code ? 'mdi-chevron-down' : 'mdi-chevron-right',
                                        size: 18
                                      }, null, 8, ["icon"])
                                    ]),
                                    _createElementVNode("strong", _hoisted_45, _toDisplayString(order.code), 1),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["aord__pay-chip", { 'is-card': order.payMethod === 'TOSS' }])
                                    }, _toDisplayString(_unref(mallPayMethodLabel)(order)), 3),
                                    _createElementVNode("span", _hoisted_46, _toDisplayString(formatDateTime(order.orderedAt)), 1),
                                    (keywordFocusCode.value === order.code)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, "검색된 주문"))
                                      : _createCommentVNode("", true),
                                    _cache[49] || (_cache[49] = _createElementVNode("span", { class: "aord__card-head-spacer" }, null, -1)),
                                    _createElementVNode("div", _hoisted_48, [
                                      (effectiveTaxStatus(order) !== 'NONE')
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            class: _normalizeClass(["sui-badge aord__tax-chip aord__tax-chip--strong", taxToneOf(order)]),
                                            "data-tour": "admin-orders-tax-open",
                                            title: "세금계산서",
                                            onClick: _withModifiers(($event: any) => (openTaxModal(order)), ["stop"])
                                          }, [
                                            _createVNode(AppIcon, {
                                              icon: "mdi-receipt-text-outline",
                                              size: 12
                                            }),
                                            _createTextVNode(" 세금계산서 · " + _toDisplayString(taxLabelOf(order)), 1)
                                          ], 10, _hoisted_49))
                                        : _createCommentVNode("", true),
                                      (order.status === 'PENDING' && !order.payNotifiedAt)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            class: _normalizeClass(["sui-badge aord__expire-badge", 
                          _unref(pendingExpireTone)(order.orderedAt) === 'alert'
                            ? 'sui-badge--red'
                            : _unref(pendingExpireTone)(order.orderedAt) === 'warn'
                              ? 'sui-badge--amber'
                              : 'sui-badge--gray'
                        ]),
                                            title: 
                          order.payMethod === 'TOSS'
                            ? `결제 없이 ${_unref(PENDING_EXPIRE_DAYS)}일 지나면 자동 취소`
                            : `입금 알림 없이 ${_unref(PENDING_EXPIRE_DAYS)}일 지나면 자동 취소`
                        
                                          }, _toDisplayString(_unref(pendingExpireLabel)(order.orderedAt)), 11, _hoisted_50))
                                        : _createCommentVNode("", true),
                                      (hasActiveClaim(order))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                            _createVNode(AppIcon, {
                                              icon: "mdi-alert-circle-outline",
                                              size: 12
                                            }),
                                            _createTextVNode(" " + _toDisplayString(activeClaimLabel(order)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (qnaOpenCountOf(order) > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                                            _createVNode(AppIcon, {
                                              icon: "mdi-comment-question-outline",
                                              size: 12
                                            }),
                                            _createTextVNode(" 문의 " + _toDisplayString(qnaOpenCountOf(order)), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (refundSummaryOf(order))
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 4,
                                            class: _normalizeClass(["sui-badge aord__refund-chip", refundSummaryOf(order)!.tone]),
                                            title: "카드를 펼쳐 상품행에서 환불 완료를 처리하세요"
                                          }, _toDisplayString(refundSummaryOf(order)!.label), 3))
                                        : _createCommentVNode("", true),
                                      (isUnpaidCancel(order))
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 5,
                                            class: "sui-badge aord__unpaid-chip",
                                            title: 
                          order.payMethod === 'TOSS'
                            ? '결제 전에 취소되어 환불이 없습니다'
                            : '입금 전에 취소되어 환불이 없습니다'
                        
                                          }, _toDisplayString(order.payMethod === 'TOSS' ? '결제 전 취소' : '입금 미진행'), 9, _hoisted_53))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["sui-badge aord__card-status", progressOf(order).tone])
                                      }, _toDisplayString(progressOf(order).title), 3)
                                    ]),
                                    _createElementVNode("ol", {
                                      class: "aord__card-dots",
                                      "aria-label": "처리현황",
                                      "data-tour": "admin-orders-progress",
                                      title: progressOf(order).hint
                                    }, [
                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fulfillSteps, (step) => {
                                        return _createElementVNode("li", {
                                          key: step.key,
                                          class: _normalizeClass({
                          'is-done': stepState(order, step.key) === 'done',
                          'is-current': stepState(order, step.key) === 'current',
                          'is-stop': order.status === 'CANCELED',
                        }),
                                          title: step.label
                                        }, null, 10, _hoisted_55)
                                      }), 64))
                                    ], 8, _hoisted_54)
                                  ]),
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("div", _hoisted_57, [
                                      _createElementVNode("strong", null, _toDisplayString(order.itemSummary), 1),
                                      _createElementVNode("span", null, "· " + _toDisplayString(order.itemCount) + "건", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_58, [
                                      (order.shippingFee)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                                            _createElementVNode("span", null, "상품 " + _toDisplayString(_unref(formatWon)(order.itemAmount)) + "원", 1),
                                            _cache[50] || (_cache[50] = _createElementVNode("em", { class: "aord__card-sum-op" }, "+", -1)),
                                            _createElementVNode("span", null, "배송 " + _toDisplayString(_unref(formatWon)(order.shippingFee)) + "원", 1),
                                            _cache[51] || (_cache[51] = _createElementVNode("em", { class: "aord__card-sum-op" }, "=", -1))
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("strong", _hoisted_60, _toDisplayString(_unref(formatWon)(order.totalAmount)) + "원", 1)
                                    ])
                                  ])
                                ], 40, _hoisted_42),
                                (expandedCode.value === order.code)
                                  ? (_openBlock(), _createElementBlock("section", {
                                      key: 0,
                                      id: `aord-detail-${order.code}`,
                                      class: "aord__card-detail",
                                      "data-tour": "admin-orders-detail"
                                    }, [
                                      (expandedLoading.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                            _createVNode(AppIcon, {
                                              icon: "mdi-loading",
                                              size: 20
                                            }),
                                            _cache[52] || (_cache[52] = _createElementVNode("span", null, "주문 상세를 불러오는 중입니다…", -1))
                                          ]))
                                        : (expandedError.value)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_63, [
                                              _createVNode(AppIcon, {
                                                icon: "mdi-alert-outline",
                                                size: 16
                                              }),
                                              _createTextVNode(" " + _toDisplayString(expandedError.value), 1)
                                            ]))
                                          : (expandedDetail.value && expandedDetail.value.code === order.code)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                (
                        (expandedDetail.value.refundPendingCount || 0) + (expandedDetail.value.refundDoneCount || 0) > 0
                          || (expandedDetail.value.status === 'CANCELED' && expandedDetail.value.cancelReason)
                      )
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                      ((expandedDetail.value.refundPendingCount || 0) + (expandedDetail.value.refundDoneCount || 0) > 0)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_65, " 환불 대기 " + _toDisplayString(expandedDetail.value.refundPendingCount || 0) + " · 완료 " + _toDisplayString(expandedDetail.value.refundDoneCount || 0), 1))
                                                        : _createCommentVNode("", true),
                                                      (expandedDetail.value.status === 'CANCELED' && expandedDetail.value.cancelReason)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(expandedDetail.value.cancelReason), 1))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("table", _hoisted_67, [
                                                  _cache[75] || (_cache[75] = _createElementVNode("caption", null, "주문 정보", -1)),
                                                  _cache[76] || (_cache[76] = _createElementVNode("colgroup", null, [
                                                    _createElementVNode("col", { class: "aord__info-col-label" }),
                                                    _createElementVNode("col"),
                                                    _createElementVNode("col", { class: "aord__info-col-label" }),
                                                    _createElementVNode("col")
                                                  ], -1)),
                                                  _createElementVNode("tbody", _hoisted_68, [
                                                    _createElementVNode("tr", null, [
                                                      _cache[53] || (_cache[53] = _createElementVNode("th", { scope: "row" }, "주문 회원", -1)),
                                                      _createElementVNode("td", null, [
                                                        (expandedDetail.value.memberCode && expandedDetail.value.orgName)
                                                          ? (_openBlock(), _createElementBlock("button", {
                                                              key: 0,
                                                              type: "button",
                                                              class: "aord__org-btn",
                                                              onClick: _cache[4] || (_cache[4] = ($event: any) => (openOrgDetail(expandedDetail.value.memberCode, expandedDetail.value.orgName, expandedDetail.value.code)))
                                                            }, _toDisplayString(expandedDetail.value.orgName), 1))
                                                          : (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(expandedDetail.value.orgName || '-'), 1)),
                                                        (expandedDetail.value.memberEmail)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(expandedDetail.value.memberEmail), 1))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _cache[54] || (_cache[54] = _createElementVNode("th", { scope: "row" }, "발주번호", -1)),
                                                      _createElementVNode("td", null, [
                                                        (expandedDetail.value.poNumber)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString(expandedDetail.value.poNumber), 1))
                                                          : (_openBlock(), _createElementBlock("span", _hoisted_72, "—"))
                                                      ])
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                      _cache[57] || (_cache[57] = _createElementVNode("th", { scope: "row" }, "배송지", -1)),
                                                      _createElementVNode("td", _hoisted_73, [
                                                        _createElementVNode("strong", null, _toDisplayString(expandedDetail.value.receiver), 1),
                                                        _cache[55] || (_cache[55] = _createElementVNode("span", { class: "aord__info-sep" }, "·", -1)),
                                                        _createElementVNode("span", null, _toDisplayString(expandedDetail.value.phone), 1),
                                                        _cache[56] || (_cache[56] = _createElementVNode("span", { class: "aord__info-sep" }, "·", -1)),
                                                        _createElementVNode("span", null, [
                                                          (expandedDetail.value.zipcode)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createTextVNode("[" + _toDisplayString(expandedDetail.value.zipcode) + "] ", 1)
                                                              ], 64))
                                                            : _createCommentVNode("", true),
                                                          _createTextVNode(" " + _toDisplayString(expandedDetail.value.address) + " " + _toDisplayString(expandedDetail.value.addressDetail), 1)
                                                        ])
                                                      ])
                                                    ]),
                                                    (expandedDetail.value.memo)
                                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_74, [
                                                          _cache[58] || (_cache[58] = _createElementVNode("th", { scope: "row" }, "요청사항", -1)),
                                                          _createElementVNode("td", _hoisted_75, _toDisplayString(expandedDetail.value.memo), 1)
                                                        ]))
                                                      : _createCommentVNode("", true),
                                                    _createElementVNode("tr", null, [
                                                      _cache[59] || (_cache[59] = _createElementVNode("th", { scope: "row" }, "주문 시각", -1)),
                                                      _createElementVNode("td", null, _toDisplayString(formatDateTime(expandedDetail.value.orderedAt)), 1),
                                                      _cache[60] || (_cache[60] = _createElementVNode("th", { scope: "row" }, "결제수단", -1)),
                                                      _createElementVNode("td", null, _toDisplayString(_unref(mallPayMethodLabel)(expandedDetail.value)), 1)
                                                    ]),
                                                    (expandedDetail.value.payMethod !== 'TOSS')
                                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_76, [
                                                          _cache[61] || (_cache[61] = _createElementVNode("th", { scope: "row" }, "입금자", -1)),
                                                          _createElementVNode("td", _hoisted_77, [
                                                            _createElementVNode("strong", null, _toDisplayString(expandedDetail.value.depositor || expandedDetail.value.receiver), 1),
                                                            (expandedDetail.value.payNotifiedAt)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_78, "「입금했어요」 " + _toDisplayString(formatDateTime(expandedDetail.value.payNotifiedAt)), 1))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_79, "입금 알림 없음"))
                                                          ])
                                                        ]))
                                                      : _createCommentVNode("", true),
                                                    _createElementVNode("tr", null, [
                                                      _cache[62] || (_cache[62] = _createElementVNode("th", { scope: "row" }, "결제확인", -1)),
                                                      _createElementVNode("td", _hoisted_80, [
                                                        (expandedDetail.value.paidAt)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_81, [
                                                              _createElementVNode("strong", null, _toDisplayString(formatDateTime(expandedDetail.value.paidAt)), 1),
                                                              (expandedDetail.value.paidBy)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_82, "· " + _toDisplayString(expandedDetail.value.paidBy), 1))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          : (_openBlock(), _createElementBlock("span", _hoisted_83, "아직 확인 전"))
                                                      ])
                                                    ])
                                                  ]),
                                                  (expandedDetail.value.taxInvoice)
                                                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_84, [
                                                        _createElementVNode("tr", _hoisted_85, [
                                                          _createElementVNode("th", _hoisted_86, [
                                                            _createVNode(AppIcon, {
                                                              icon: "mdi-receipt-text-outline",
                                                              size: 14
                                                            }),
                                                            _cache[63] || (_cache[63] = _createElementVNode("span", null, "세금계산서", -1)),
                                                            _createElementVNode("button", {
                                                              type: "button",
                                                              class: "aord__info-more",
                                                              onClick: _cache[5] || (_cache[5] = ($event: any) => (openTaxModal(expandedDetail.value!)))
                                                            }, "관리하기")
                                                          ])
                                                        ]),
                                                        _createElementVNode("tr", null, [
                                                          _cache[65] || (_cache[65] = _createElementVNode("th", { scope: "row" }, "상태", -1)),
                                                          _createElementVNode("td", null, [
                                                            _createElementVNode("button", {
                                                              type: "button",
                                                              class: _normalizeClass(["sui-badge aord__tax-chip", taxToneOf(expandedDetail.value)]),
                                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (openTaxModal(expandedDetail.value!)))
                                                            }, _toDisplayString(taxStatusLabel(expandedDetail.value.taxStatus)), 3),
                                                            (effectiveTaxStatus(expandedDetail.value) === 'DONE' && expandedDetail.value.taxAt)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_87, "발행 " + _toDisplayString(formatDateTime(expandedDetail.value.taxAt)), 1))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _cache[66] || (_cache[66] = _createElementVNode("th", { scope: "row" }, "발행 문서", -1)),
                                                          _createElementVNode("td", null, [
                                                            (expandedDetail.value.taxDocUrl)
                                                              ? (_openBlock(), _createElementBlock("a", {
                                                                  key: 0,
                                                                  class: "aord__info-link",
                                                                  href: taxDocHref(expandedDetail.value.taxDocUrl),
                                                                  target: "_blank",
                                                                  rel: "noopener"
                                                                }, [
                                                                  _createVNode(AppIcon, {
                                                                    icon: "mdi-file-document-outline",
                                                                    size: 14
                                                                  }),
                                                                  _cache[64] || (_cache[64] = _createTextVNode(" 세금계산서 열기 ", -1))
                                                                ], 8, _hoisted_88))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_89, "발행 후 링크 표시"))
                                                          ])
                                                        ]),
                                                        _createElementVNode("tr", null, [
                                                          _cache[67] || (_cache[67] = _createElementVNode("th", { scope: "row" }, "상호", -1)),
                                                          _createElementVNode("td", null, [
                                                            (expandedDetail.value.bizName)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(expandedDetail.value.bizName), 1))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_91, "-"))
                                                          ]),
                                                          _cache[68] || (_cache[68] = _createElementVNode("th", { scope: "row" }, "사업자번호", -1)),
                                                          _createElementVNode("td", null, [
                                                            (expandedDetail.value.bizNum)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString(_unref(formatBizNumber)(expandedDetail.value.bizNum)), 1))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_93, "-"))
                                                          ])
                                                        ]),
                                                        _createElementVNode("tr", null, [
                                                          _cache[70] || (_cache[70] = _createElementVNode("th", { scope: "row" }, "수신 이메일", -1)),
                                                          _createElementVNode("td", null, [
                                                            (taxDisplayEmail(expandedDetail.value))
                                                              ? (_openBlock(), _createElementBlock("a", {
                                                                  key: 0,
                                                                  class: "aord__info-link",
                                                                  href: `mailto:${taxDisplayEmail(expandedDetail.value)}`
                                                                }, _toDisplayString(taxDisplayEmail(expandedDetail.value)), 9, _hoisted_94))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_95, "-")),
                                                            (!expandedDetail.value.taxEmail && expandedDetail.value.memberEmail)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_96, "회원 프로필"))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _cache[71] || (_cache[71] = _createElementVNode("th", { scope: "row" }, "사업자등록증", -1)),
                                                          _createElementVNode("td", null, [
                                                            (taxDisplayBizCert(expandedDetail.value))
                                                              ? (_openBlock(), _createElementBlock("a", {
                                                                  key: 0,
                                                                  class: "aord__info-link",
                                                                  href: bizCertHref(taxDisplayBizCert(expandedDetail.value)),
                                                                  target: "_blank",
                                                                  rel: "noopener"
                                                                }, [
                                                                  _createVNode(AppIcon, {
                                                                    icon: "mdi-file-image-outline",
                                                                    size: 14
                                                                  }),
                                                                  _cache[69] || (_cache[69] = _createTextVNode(" 등록증 열기 ", -1))
                                                                ], 8, _hoisted_97))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_98, "미등록")),
                                                            (!expandedDetail.value.bizCert && expandedDetail.value.memberBizCert)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_99, "회원 프로필"))
                                                              : _createCommentVNode("", true)
                                                          ])
                                                        ]),
                                                        (expandedDetail.value.taxRejectReason)
                                                          ? (_openBlock(), _createElementBlock("tr", _hoisted_100, [
                                                              _cache[72] || (_cache[72] = _createElementVNode("th", { scope: "row" }, "반려 사유", -1)),
                                                              _createElementVNode("td", _hoisted_101, _toDisplayString(expandedDetail.value.taxRejectReason), 1)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (openQnasOf(expandedDetail.value).length)
                                                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_102, [
                                                        _createElementVNode("tr", _hoisted_103, [
                                                          _createElementVNode("th", _hoisted_104, [
                                                            _createVNode(AppIcon, {
                                                              icon: "mdi-comment-question-outline",
                                                              size: 14
                                                            }),
                                                            _cache[73] || (_cache[73] = _createElementVNode("span", null, "상품 문의", -1)),
                                                            _createElementVNode("em", _hoisted_105, " 미답변 " + _toDisplayString(openQnasOf(expandedDetail.value).length), 1)
                                                          ])
                                                        ]),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(openQnasOf(expandedDetail.value), (qna) => {
                                                          return (_openBlock(), _createElementBlock("tr", {
                                                            key: qna.idx
                                                          }, [
                                                            _createElementVNode("th", _hoisted_106, _toDisplayString(qna.productName || '상품'), 1),
                                                            _createElementVNode("td", _hoisted_107, [
                                                              _createElementVNode("div", _hoisted_108, [
                                                                _createElementVNode("span", null, _toDisplayString(qna.question), 1),
                                                                _createVNode(_component_router_link, {
                                                                  class: "aord__info-link",
                                                                  to: {
                                  path: '/admin/cs',
                                  query: { tab: 'qna', unanswered: '1', keyword: expandedDetail.value.code },
                                }
                                                                }, {
                                                                  default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                                                    _createTextVNode(" 문의 화면에서 보기 ", -1)
                                                                  ]))]),
                                                                  _: 1
                                                                }, 8, ["to"])
                                                              ])
                                                            ])
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("table", _hoisted_109, [
                                                  _cache[83] || (_cache[83] = _createElementVNode("caption", null, "주문 상품", -1)),
                                                  _cache[84] || (_cache[84] = _createElementVNode("thead", null, [
                                                    _createElementVNode("tr", null, [
                                                      _createElementVNode("th", {
                                                        scope: "col",
                                                        class: "is-item"
                                                      }, "상품"),
                                                      _createElementVNode("th", {
                                                        scope: "col",
                                                        class: "is-num"
                                                      }, "단가"),
                                                      _createElementVNode("th", {
                                                        scope: "col",
                                                        class: "is-num is-qty"
                                                      }, "수량"),
                                                      _createElementVNode("th", {
                                                        scope: "col",
                                                        class: "is-num"
                                                      }, "금액"),
                                                      _createElementVNode("th", {
                                                        scope: "col",
                                                        class: "is-status"
                                                      }, "상태 · 배송")
                                                    ])
                                                  ], -1)),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expandedSellerGroups.value, (group) => {
                                                    return (_openBlock(), _createElementBlock("tbody", {
                                                      key: group.storeName
                                                    }, [
                                                      _createElementVNode("tr", _hoisted_110, [
                                                        _createElementVNode("th", _hoisted_111, [
                                                          _createElementVNode("span", _hoisted_112, [
                                                            _createVNode(AppIcon, {
                                                              icon: "mdi-storefront-outline",
                                                              size: 16
                                                            }),
                                                            _createElementVNode("strong", null, _toDisplayString(group.storeName), 1)
                                                          ]),
                                                          _createElementVNode("em", null, _toDisplayString(group.items.length) + "건 · " + _toDisplayString(_unref(formatWon)(group.amount)) + "원", 1)
                                                        ])
                                                      ]),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                          key: item.idx,
                                                          class: _normalizeClass(["aord__items-row", {
                            'is-claim-pending': isClaimPending(item),
                            'is-refund-pending': item.refundStatus === 'PENDING',
                          }])
                                                        }, [
                                                          _createElementVNode("td", _hoisted_113, [
                                                            _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                                                            (item.option)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString(item.option), 1))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _createElementVNode("td", _hoisted_115, _toDisplayString(_unref(formatWon)(item.price)) + "원", 1),
                                                          _createElementVNode("td", _hoisted_116, _toDisplayString(item.qty), 1),
                                                          _createElementVNode("td", _hoisted_117, _toDisplayString(_unref(formatWon)(item.amount)) + "원", 1),
                                                          _createElementVNode("td", _hoisted_118, [
                                                            _createElementVNode("div", _hoisted_119, [
                                                              _createElementVNode("span", {
                                                                class: _normalizeClass(["sui-badge", [itemTone(item.status), isClaimPending(item) ? 'aord__items-claim-pill' : '']])
                                                              }, [
                                                                (isClaimPending(item))
                                                                  ? (_openBlock(), _createBlock(AppIcon, {
                                                                      key: 0,
                                                                      icon: "mdi-alert-circle-outline",
                                                                      size: 12
                                                                    }))
                                                                  : _createCommentVNode("", true),
                                                                _createTextVNode(" " + _toDisplayString(itemStatusLabel(item.status)), 1)
                                                              ], 2),
                                                              (isClaimPending(item) && item.claimAt)
                                                                ? (_openBlock(), _createElementBlock("span", {
                                                                    key: 0,
                                                                    class: _normalizeClass(["aord__items-claim-sla", claimSlaTone(item)]),
                                                                    title: `${formatDateTime(item.claimAt)} 요청`
                                                                  }, _toDisplayString(claimSlaLabel(item)), 11, _hoisted_120))
                                                                : (isClaimRejected(item))
                                                                  ? (_openBlock(), _createElementBlock("span", {
                                                                      key: 1,
                                                                      class: "sui-badge sui-badge--gray aord__items-claim-rejected",
                                                                      title: item.claimResolvedAt ? `${formatDateTime(item.claimResolvedAt)} 반려` : ''
                                                                    }, [
                                                                      _createVNode(AppIcon, {
                                                                        icon: "mdi-close-circle-outline",
                                                                        size: 12
                                                                      }),
                                                                      _cache[77] || (_cache[77] = _createTextVNode(" 클레임 반려 ", -1))
                                                                    ], 8, _hoisted_121))
                                                                  : _createCommentVNode("", true),
                                                              (item.refundStatus === 'DONE')
                                                                ? (_openBlock(), _createElementBlock("span", {
                                                                    key: 2,
                                                                    class: "sui-badge sui-badge--green",
                                                                    title: item.refundAt ? `${formatDateTime(item.refundAt)} 환불 완료` : '환불 완료'
                                                                  }, [
                                                                    _createVNode(AppIcon, {
                                                                      icon: "mdi-check-circle-outline",
                                                                      size: 12
                                                                    }),
                                                                    _cache[78] || (_cache[78] = _createTextVNode(" 환불 완료 ", -1))
                                                                  ], 8, _hoisted_122))
                                                                : _createCommentVNode("", true),
                                                              (hasItemPrimaryActions(item))
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                                                    (isClaimPending(item))
                                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                          _createElementVNode("button", {
                                                                            type: "button",
                                                                            class: "sui-btn sui-btn--sm sui-btn--primary aord__items-claim-approve",
                                                                            "data-tour": "admin-orders-claim-approve",
                                                                            disabled: claimBusy.value === item.idx,
                                                                            onClick: ($event: any) => (approveClaim(item))
                                                                          }, [
                                                                            _createVNode(AppIcon, {
                                                                              icon: "mdi-check-circle-outline",
                                                                              size: 16
                                                                            }),
                                                                            _cache[79] || (_cache[79] = _createTextVNode(" 승인 ", -1))
                                                                          ], 8, _hoisted_124),
                                                                          _createElementVNode("button", {
                                                                            type: "button",
                                                                            class: "sui-btn sui-btn--sm aord__items-claim-reject",
                                                                            "data-tour": "admin-orders-claim-reject",
                                                                            disabled: claimBusy.value === item.idx,
                                                                            onClick: ($event: any) => (openClaimReject(item))
                                                                          }, [
                                                                            _createVNode(AppIcon, {
                                                                              icon: "mdi-close-circle-outline",
                                                                              size: 16
                                                                            }),
                                                                            _cache[80] || (_cache[80] = _createTextVNode(" 반려 ", -1))
                                                                          ], 8, _hoisted_125)
                                                                        ], 64))
                                                                      : _createCommentVNode("", true),
                                                                    (item.refundStatus === 'PENDING')
                                                                      ? (_openBlock(), _createElementBlock("button", {
                                                                          key: 1,
                                                                          type: "button",
                                                                          class: "sui-btn sui-btn--sm aord__items-refund-btn",
                                                                          "data-tour": "admin-orders-refund-done",
                                                                          title: "환불 송금 완료로 표시",
                                                                          onClick: ($event: any) => (openRefundDone(item))
                                                                        }, [
                                                                          _createVNode(AppIcon, {
                                                                            icon: "mdi-cash-refund",
                                                                            size: 16
                                                                          }),
                                                                          _createTextVNode(" 환불 완료 처리 · " + _toDisplayString(_unref(formatWon)(item.refundAmount || item.amount)) + "원 ", 1)
                                                                        ], 8, _hoisted_126))
                                                                      : _createCommentVNode("", true),
                                                                    (canAdminAdjust(item) && !hasItemShipmentUi(item))
                                                                      ? (_openBlock(), _createElementBlock("button", {
                                                                          key: 2,
                                                                          type: "button",
                                                                          class: _normalizeClass(["sui-btn sui-btn--sm aord__items-adjust-btn", { 'is-quiet': isItemActionBusy(item) }]),
                                                                          "data-tour": "admin-orders-adjust",
                                                                          title: "전화 환불·배송 상태를 직접 바꿉니다",
                                                                          onClick: ($event: any) => (openAdjust(item))
                                                                        }, [
                                                                          _createVNode(AppIcon, {
                                                                            icon: "mdi-tune-variant",
                                                                            size: 16
                                                                          }),
                                                                          _cache[81] || (_cache[81] = _createTextVNode(" 조정 ", -1))
                                                                        ], 10, _hoisted_127))
                                                                      : _createCommentVNode("", true)
                                                                  ]))
                                                                : _createCommentVNode("", true),
                                                              (hasItemShipmentUi(item))
                                                                ? (_openBlock(), _createBlock(MallShipmentLedger, {
                                                                    key: 4,
                                                                    item: item,
                                                                    "show-reship": canExtraShip(item),
                                                                    "reship-tour": "admin-orders-extra-ship",
                                                                    "lookup-tour": "admin-orders-tracking",
                                                                    onTrack: ($event: any) => (openItemShipment(item, $event)),
                                                                    onReship: ($event: any) => (openExtraShip(item))
                                                                  }, {
                                                                    actions: _withCtx(() => [
                                                                      (canAdminAdjust(item))
                                                                        ? (_openBlock(), _createElementBlock("button", {
                                                                            key: 0,
                                                                            type: "button",
                                                                            class: "sui-btn sui-btn--sm aord__items-adjust-btn is-quiet",
                                                                            "data-tour": "admin-orders-adjust",
                                                                            title: "전화 환불·배송 상태를 직접 바꿉니다",
                                                                            onClick: ($event: any) => (openAdjust(item))
                                                                          }, " 조정 ", 8, _hoisted_128))
                                                                        : _createCommentVNode("", true)
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["item", "show-reship", "onTrack", "onReship"]))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            (item.claimReason && (isClaimPending(item) || isClaimRejected(item)))
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                                                                  _createVNode(AppIcon, {
                                                                    icon: "mdi-message-text-outline",
                                                                    size: 13
                                                                  }),
                                                                  _createElementVNode("span", null, [
                                                                    _createElementVNode("em", null, _toDisplayString(claimRequestLabel(item)) + " 사유", 1),
                                                                    _createTextVNode(" " + _toDisplayString(item.claimReason), 1)
                                                                  ])
                                                                ]))
                                                              : _createCommentVNode("", true),
                                                            (isClaimRejected(item) && item.claimRejectReason)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                                                  _createVNode(AppIcon, {
                                                                    icon: "mdi-alert-outline",
                                                                    size: 13
                                                                  }),
                                                                  _createElementVNode("span", null, [
                                                                    _cache[82] || (_cache[82] = _createElementVNode("em", null, "반려 사유", -1)),
                                                                    _createTextVNode(" " + _toDisplayString(item.claimRejectReason), 1)
                                                                  ])
                                                                ]))
                                                              : _createCommentVNode("", true)
                                                          ])
                                                        ], 2))
                                                      }), 128))
                                                    ]))
                                                  }), 128))
                                                ]),
                                                _createElementVNode("div", _hoisted_131, [
                                                  _createElementVNode("label", _hoisted_132, [
                                                    _cache[85] || (_cache[85] = _createElementVNode("span", null, [
                                                      _createTextVNode("내부 메모 "),
                                                      _createElementVNode("em", null, "(구매자에게 보이지 않음)")
                                                    ], -1)),
                                                    _withDirectives(_createElementVNode("textarea", {
                                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((adminMemoDraft).value = $event)),
                                                      rows: "2",
                                                      maxlength: "500",
                                                      placeholder: "입금 확인 특이사항, 연락 기록 등을 남겨 두세요."
                                                    }, null, 512), [
                                                      [
                                                        _vModelText,
                                                        adminMemoDraft.value,
                                                        void 0,
                                                        { trim: true }
                                                      ]
                                                    ]),
                                                    _createElementVNode("button", {
                                                      type: "button",
                                                      class: "sui-btn sui-btn--sm",
                                                      disabled: memoBusy.value || adminMemoDraft.value === (expandedDetail.value.adminMemo || ''),
                                                      onClick: saveMemo
                                                    }, _toDisplayString(memoBusy.value ? '저장 중…' : '메모 저장'), 9, _hoisted_133)
                                                  ]),
                                                  _createElementVNode("table", _hoisted_134, [
                                                    _cache[92] || (_cache[92] = _createElementVNode("caption", null, "결제 합계", -1)),
                                                    _createElementVNode("tbody", null, [
                                                      _createElementVNode("tr", null, [
                                                        _cache[86] || (_cache[86] = _createElementVNode("th", { scope: "row" }, "상품 합계", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(_unref(formatWon)(expandedDetail.value.itemAmount)) + "원", 1)
                                                      ]),
                                                      _createElementVNode("tr", null, [
                                                        _cache[87] || (_cache[87] = _createElementVNode("th", { scope: "row" }, "배송비", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(_unref(formatWon)(expandedDetail.value.shippingFee)) + "원", 1)
                                                      ]),
                                                      _createElementVNode("tr", null, [
                                                        _cache[88] || (_cache[88] = _createElementVNode("th", { scope: "row" }, "함우리 마진 합계", -1)),
                                                        _createElementVNode("td", _hoisted_135, _toDisplayString(_unref(formatWon)(expandedPlatformMargin.value)) + "원", 1)
                                                      ]),
                                                      _createElementVNode("tr", {
                                                        class: _normalizeClass({ 'is-total': !expandedRefund.value.refunded })
                                                      }, [
                                                        _createElementVNode("th", _hoisted_136, _toDisplayString(expandedDetail.value.payMethod === 'TOSS' ? '결제금액' : '입금액'), 1),
                                                        _createElementVNode("td", null, _toDisplayString(_unref(formatWon)(expandedDetail.value.totalAmount)) + "원", 1)
                                                      ], 2),
                                                      (expandedRefund.value.refunded)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_137, [
                                                            _cache[89] || (_cache[89] = _createElementVNode("th", { scope: "row" }, "환불 완료", -1)),
                                                            _createElementVNode("td", null, "-" + _toDisplayString(_unref(formatWon)(expandedRefund.value.refunded)) + "원", 1)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (expandedRefund.value.refundPending)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_138, [
                                                            _cache[90] || (_cache[90] = _createElementVNode("th", { scope: "row" }, "환불 대기", -1)),
                                                            _createElementVNode("td", null, _toDisplayString(_unref(formatWon)(expandedRefund.value.refundPending)) + "원", 1)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (expandedRefund.value.refunded)
                                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_139, [
                                                            _cache[91] || (_cache[91] = _createElementVNode("th", { scope: "row" }, "결제 잔액", -1)),
                                                            _createElementVNode("td", null, _toDisplayString(_unref(formatWon)(expandedRefund.value.balance)) + "원", 1)
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("footer", _hoisted_140, [
                                                  _createElementVNode("p", _hoisted_141, [
                                                    _createVNode(AppIcon, {
                                                      icon: "mdi-information-outline",
                                                      size: 15
                                                    }),
                                                    _createElementVNode("span", null, _toDisplayString(progressOf(expandedDetail.value).hint), 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_142, [
                                                    (expandedDetail.value.status === 'PENDING' && expandedDetail.value.payMethod !== 'TOSS')
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 0,
                                                          type: "button",
                                                          class: "sui-btn sui-btn--sm sui-btn--primary",
                                                          disabled: working.value === expandedDetail.value.code,
                                                          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (onConfirm(expandedDetail.value)), ["stop"]))
                                                        }, " 결제확인 ", 8, _hoisted_143))
                                                      : _createCommentVNode("", true),
                                                    (canUnconfirm(expandedDetail.value))
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 1,
                                                          type: "button",
                                                          class: "sui-btn sui-btn--sm",
                                                          "data-tour": "admin-orders-unconfirm",
                                                          title: "결제확인만 취소합니다. 주문은 입금 대기로 남습니다.",
                                                          disabled: working.value === expandedDetail.value.code,
                                                          onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (onUnconfirm(expandedDetail.value)), ["stop"]))
                                                        }, " 결제확인 취소 ", 8, _hoisted_144))
                                                      : _createCommentVNode("", true),
                                                    (trackItemsOf(expandedDetail.value).length)
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 2,
                                                          type: "button",
                                                          class: "sui-btn sui-btn--sm",
                                                          "data-tour": "admin-orders-tracking",
                                                          onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (openTrackingFromOrder(expandedDetail.value)), ["stop"]))
                                                        }, " 배송조회 "))
                                                      : _createCommentVNode("", true),
                                                    (expandedDetail.value.status !== 'CANCELED' && canCancelOrder(expandedDetail.value))
                                                      ? (_openBlock(), _createElementBlock("button", {
                                                          key: 3,
                                                          type: "button",
                                                          class: "sui-btn sui-btn--sm sui-btn--ghost",
                                                          "data-tour": "admin-orders-cancel",
                                                          title: "주문을 끝냅니다. 다시 살릴 수 없습니다.",
                                                          onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (onCancel(expandedDetail.value)), ["stop"]))
                                                        }, " 주문 취소 "))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ])
                                              ], 64))
                                            : _createCommentVNode("", true)
                                    ], 8, _hoisted_61))
                                  : _createCommentVNode("", true)
                              ], 2))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_145, "해당 주문이 없습니다."))
                    ], 2))
                  }), 128))
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_146, [
            _createVNode(AppIcon, {
              icon: "mdi-receipt-text-outline",
              size: 32
            }),
            (loading.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_147, "불러오는 중입니다…"))
              : (keyword.value.trim())
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("p", _hoisted_148, [
                      _createElementVNode("strong", null, "「" + _toDisplayString(keyword.value.trim()) + "」", 1),
                      _cache[93] || (_cache[93] = _createTextVNode("에 해당하는 주문을 찾지 못했습니다. ", -1))
                    ]),
                    _cache[94] || (_cache[94] = _createElementVNode("p", { class: "aord__empty-sub" }, " 주문번호 · 입금자명 · 회원명 어느 하나에도 일치하지 않습니다. 취소·삭제된 주문일 수 있어요. ", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "sui-btn is-primary",
                      onClick: clearKeyword
                    }, " 검색 지우고 전체 보기 ")
                  ], 64))
                : (_openBlock(), _createElementBlock("p", _hoisted_149, "조건에 맞는 주문이 없습니다."))
          ]))
    ]),
    (cancelTarget.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "aord__modal",
          onClick: _withModifiers(closeCancel, ["self"])
        }, [
          _createElementVNode("form", {
            class: "aord__cancel-dialog",
            onSubmit: _withModifiers(submitCancel, ["prevent"])
          }, [
            _cache[101] || (_cache[101] = _createElementVNode("h3", null, "주문 취소", -1)),
            _createElementVNode("p", _hoisted_150, [
              _cache[98] || (_cache[98] = _createTextVNode(" 이 주문을 끝냅니다. 다시 살릴 수 없습니다. ", -1)),
              (cancelTarget.value.status === 'PAID' && cancelTarget.value.payMethod === 'TOSS')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" 결제된 카드·간편결제 금액이 결제 수단으로 환불됩니다. ")
                  ], 64))
                : (cancelTarget.value.status === 'PAID')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[95] || (_cache[95] = _createTextVNode(" 입금 확인만 잘못 눌렀다면 닫고 ", -1)),
                      _cache[96] || (_cache[96] = _createElementVNode("strong", null, "결제확인 취소", -1)),
                      _cache[97] || (_cache[97] = _createTextVNode("를 누르세요. 그러면 주문은 입금 대기로 남습니다. ", -1))
                    ], 64))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("p", _hoisted_151, [
              _createTextVNode(_toDisplayString(cancelTarget.value.code) + " · 주문금액 " + _toDisplayString(_unref(formatWon)(cancelTarget.value.totalAmount)) + "원 ", 1),
              _createElementVNode("span", _hoisted_152, [
                _createTextVNode(" (상품 " + _toDisplayString(_unref(formatWon)(cancelTarget.value.itemAmount)) + "원 ", 1),
                (cancelTarget.value.shippingFee)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" · 배송 " + _toDisplayString(_unref(formatWon)(cancelTarget.value.shippingFee)) + "원 — 전량 취소 시 포함 ", 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _cache[99] || (_cache[99] = _createTextVNode(" ) ", -1))
              ])
            ]),
            _createElementVNode("label", _hoisted_153, [
              _cache[100] || (_cache[100] = _createElementVNode("span", null, "취소 사유", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((cancelReason).value = $event)),
                class: "sui-input",
                rows: "4",
                maxlength: "255",
                placeholder: "구매 기관·판매업체에 안내할 취소 사유를 적어 주세요."
              }, null, 512), [
                [
                  _vModelText,
                  cancelReason.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_154, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                onClick: closeCancel
              }, "닫기"),
              _createElementVNode("button", {
                type: "submit",
                class: "sui-btn sui-btn--primary",
                disabled: !cancelReason.value || working.value === cancelTarget.value.code
              }, " 취소 확정 ", 8, _hoisted_155)
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (extraShipTarget.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "aord__modal",
          onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (extraShipTarget.value = null), ["self"]))
        }, [
          _createElementVNode("form", {
            class: "aord__extra-dialog",
            onSubmit: _withModifiers(submitExtraShip, ["prevent"])
          }, [
            _createElementVNode("header", null, [
              _createElementVNode("h3", null, [
                _createVNode(AppIcon, {
                  icon: "mdi-truck-plus-outline",
                  size: 18
                }),
                _cache[102] || (_cache[102] = _createTextVNode(" 재발송 등록 ", -1))
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "aord__close",
                "aria-label": "닫기",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (extraShipTarget.value = null))
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-close",
                  size: 18
                })
              ])
            ]),
            _createElementVNode("p", _hoisted_156, [
              _createElementVNode("strong", null, _toDisplayString(extraShipTarget.value.orderCode || expandedDetail.value?.code), 1),
              _createTextVNode(" · " + _toDisplayString(extraShipTarget.value.storeName) + " · " + _toDisplayString(extraShipTarget.value.name), 1)
            ]),
            _cache[106] || (_cache[106] = _createElementVNode("p", { class: "aord__extra-note" }, " 주문번호는 바뀌지 않습니다. 오발송·누락으로 택배를 한 번 더 보냈을 때, 본발송과 다른 송장만 추가합니다. 카톤 단위는 주문 수량일 뿐 배송을 나누지 않습니다. ", -1)),
            _createElementVNode("label", _hoisted_157, [
              _cache[103] || (_cache[103] = _createElementVNode("span", null, "택배사", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((extraShipForm.courier) = $event)),
                class: "sui-select"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COURIERS), (name) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: name,
                    value: name
                  }, _toDisplayString(name), 9, _hoisted_158))
                }), 128))
              ], 512), [
                [_vModelSelect, extraShipForm.courier]
              ])
            ]),
            _createElementVNode("label", _hoisted_159, [
              _createElementVNode("span", null, " 재발송 송장번호" + _toDisplayString(isDirectCourierName(extraShipForm.courier) ? ' (직접배송은 생략 가능)' : ''), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((extraShipForm.invoice) = $event)),
                class: "sui-input",
                placeholder: "숫자만 입력"
              }, null, 512), [
                [
                  _vModelText,
                  extraShipForm.invoice,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_160, [
              _cache[104] || (_cache[104] = _createElementVNode("span", null, "이번에 보내는 수량", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((extraShipForm.qty) = $event)),
                class: "sui-input",
                type: "number",
                min: "1",
                max: extraShipTarget.value.qty
              }, null, 8, _hoisted_161), [
                [
                  _vModelText,
                  extraShipForm.qty,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_162, [
              _cache[105] || (_cache[105] = _createElementVNode("span", null, "사유", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((extraShipForm.memo) = $event)),
                class: "sui-input",
                maxlength: "120",
                placeholder: "예: 오발송 보충"
              }, null, 512), [
                [
                  _vModelText,
                  extraShipForm.memo,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_163, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (extraShipTarget.value = null))
              }, "취소"),
              _createElementVNode("button", {
                type: "submit",
                class: "sui-btn sui-btn--primary",
                disabled: extraShipBusy.value
              }, _toDisplayString(extraShipBusy.value ? '등록 중…' : '재발송 등록'), 9, _hoisted_164)
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (claimRejectTarget.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "aord__modal",
          onClick: _withModifiers(closeClaimReject, ["self"])
        }, [
          _createElementVNode("form", {
            class: "aord__extra-dialog",
            onSubmit: _withModifiers(submitClaimReject, ["prevent"])
          }, [
            _createElementVNode("header", null, [
              _createElementVNode("h3", null, [
                _createVNode(AppIcon, {
                  icon: "mdi-close-circle-outline",
                  size: 18
                }),
                _createTextVNode(" " + _toDisplayString(claimRequestLabel(claimRejectTarget.value)) + " 반려 ", 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "aord__close",
                "aria-label": "닫기",
                onClick: closeClaimReject
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-close",
                  size: 18
                })
              ])
            ]),
            _createElementVNode("p", _hoisted_165, [
              _createElementVNode("strong", null, _toDisplayString(expandedDetail.value?.code), 1),
              _createTextVNode(" · " + _toDisplayString(claimRejectTarget.value.storeName) + " · " + _toDisplayString(claimRejectTarget.value.name) + " · " + _toDisplayString(claimRejectTarget.value.qty) + "개 ", 1)
            ]),
            (claimRejectTarget.value.claimReason)
              ? (_openBlock(), _createElementBlock("p", _hoisted_166, [
                  _cache[107] || (_cache[107] = _createElementVNode("em", null, "구매 기관 사유", -1)),
                  _createTextVNode(" " + _toDisplayString(claimRejectTarget.value.claimReason), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("label", _hoisted_167, [
              _cache[108] || (_cache[108] = _createElementVNode("span", null, [
                _createTextVNode("반려 사유 "),
                _createElementVNode("em", null, "(구매자에게 안내됩니다)")
              ], -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((claimRejectReason).value = $event)),
                class: "sui-input",
                rows: "4",
                maxlength: "255",
                placeholder: "예: 배송이 이미 시작되어 취소가 어렵습니다."
              }, null, 512), [
                [
                  _vModelText,
                  claimRejectReason.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_168, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                onClick: closeClaimReject
              }, "닫기"),
              _createElementVNode("button", {
                type: "submit",
                class: "sui-btn sui-btn--danger",
                disabled: !claimRejectReason.value || claimBusy.value === claimRejectTarget.value.idx
              }, _toDisplayString(claimBusy.value === claimRejectTarget.value.idx ? '처리 중…' : '반려 확정'), 9, _hoisted_169)
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (adjustTarget.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "aord__modal",
          onClick: _withModifiers(closeAdjust, ["self"])
        }, [
          _createElementVNode("form", {
            class: "aord__refund-dialog aord__adjust-dialog",
            onSubmit: _withModifiers(submitAdjust, ["prevent"])
          }, [
            _createElementVNode("header", null, [
              _createElementVNode("h3", null, [
                _createVNode(AppIcon, {
                  icon: "mdi-tune-variant",
                  size: 18
                }),
                _cache[109] || (_cache[109] = _createTextVNode(" 주문 조정 ", -1))
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "aord__close",
                "aria-label": "닫기",
                onClick: closeAdjust
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-close",
                  size: 18
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_170, [
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, _toDisplayString(expandedDetail.value?.code), 1),
                _createElementVNode("em", null, _toDisplayString(adjustTarget.value.storeName) + " · " + _toDisplayString(adjustTarget.value.name) + " · " + _toDisplayString(adjustTarget.value.qty) + "개", 1),
                _createElementVNode("em", null, "지금 " + _toDisplayString(itemStatusLabel(adjustTarget.value.status)), 1)
              ]),
              _createElementVNode("strong", _hoisted_171, _toDisplayString(_unref(formatWon)(adjustTarget.value.refundAmount || adjustTarget.value.amount)) + "원 ", 1)
            ]),
            _cache[116] || (_cache[116] = _createElementVNode("p", { class: "aord__extra-note" }, " 구매자가 화면에서 요청하지 않아도 전화·CS로 처리한 내용을 여기에 반영합니다. 환불 완료는 되돌릴 수 없습니다. ", -1)),
            _createElementVNode("fieldset", _hoisted_172, [
              _cache[112] || (_cache[112] = _createElementVNode("legend", null, "무엇을 할까요", -1)),
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((adjustForm.action) = $event)),
                  type: "radio",
                  value: "refund-done"
                }, null, 512), [
                  [_vModelRadio, adjustForm.action]
                ]),
                _createElementVNode("span", null, [
                  _createElementVNode("strong", null, _toDisplayString(expandedDetail.value?.payMethod === 'TOSS' ? '카드 결제 취소' : '환불 완료로 표시'), 1),
                  _createTextVNode(" " + _toDisplayString(expandedDetail.value?.payMethod === 'TOSS'
                  ? '상품을 취소하고 결제했던 카드·간편결제로 환불합니다.'
                  : '송금까지 끝났으면 상품을 취소하고 환불 완료로 둡니다.'), 1)
                ])
              ]),
              (expandedDetail.value?.payMethod !== 'TOSS')
                ? (_openBlock(), _createElementBlock("label", _hoisted_173, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((adjustForm.action) = $event)),
                      type: "radio",
                      value: "refund-pending"
                    }, null, 512), [
                      [_vModelRadio, adjustForm.action]
                    ]),
                    _cache[110] || (_cache[110] = _createElementVNode("span", null, [
                      _createElementVNode("strong", null, "환불 대기로 두기"),
                      _createTextVNode(" 상품만 취소하고, 송금은 나중에 「환불 완료 처리」로 마감합니다. ")
                    ], -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((adjustForm.action) = $event)),
                  type: "radio",
                  value: "status"
                }, null, 512), [
                  [_vModelRadio, adjustForm.action]
                ]),
                _cache[111] || (_cache[111] = _createElementVNode("span", null, [
                  _createElementVNode("strong", null, "배송 상태만 바꾸기"),
                  _createTextVNode(" 발송 준비·배송중·배송완료·구매확정 등을 직접 맞춥니다. ")
                ], -1))
              ])
            ]),
            (adjustForm.action === 'status')
              ? (_openBlock(), _createElementBlock("label", _hoisted_174, [
                  _cache[113] || (_cache[113] = _createElementVNode("span", null, "바꿀 상태", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((adjustForm.status) = $event))
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ADMIN_ADJUST_STATUSES, (row) => {
                      return _createElementVNode("option", {
                        key: row.value,
                        value: row.value
                      }, _toDisplayString(row.label), 9, _hoisted_175)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, adjustForm.status]
                  ])
                ]))
              : _createCommentVNode("", true),
            (adjustForm.action !== 'status' && expandedDetail.value?.payMethod !== 'TOSS')
              ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                  _createElementVNode("label", null, [
                    _createElementVNode("span", null, "은행" + _toDisplayString(adjustForm.action === 'refund-done' ? '' : ' (선택)'), 1),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((adjustForm.bank) = $event))
                    }, [
                      _cache[114] || (_cache[114] = _createElementVNode("option", { value: "" }, "선택", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MALL_BANKS), (bank) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: bank,
                          value: bank
                        }, _toDisplayString(bank), 9, _hoisted_177))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, adjustForm.bank]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _createElementVNode("span", null, "계좌번호" + _toDisplayString(adjustForm.action === 'refund-done' ? '' : ' (선택)'), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((adjustForm.account) = $event)),
                      type: "text",
                      inputmode: "numeric",
                      maxlength: "50"
                    }, null, 512), [
                      [
                        _vModelText,
                        adjustForm.account,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_178, [
                    _createElementVNode("span", null, "예금주" + _toDisplayString(adjustForm.action === 'refund-done' ? '' : ' (선택)'), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((adjustForm.holder) = $event)),
                      type: "text",
                      maxlength: "50"
                    }, null, 512), [
                      [
                        _vModelText,
                        adjustForm.holder,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("label", _hoisted_179, [
              _cache[115] || (_cache[115] = _createElementVNode("span", null, "사유", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((adjustForm.reason) = $event)),
                rows: "3",
                maxlength: "255",
                placeholder: "예: 전화로 환불 요청 · 담당자 홍길동"
              }, null, 512), [
                [
                  _vModelText,
                  adjustForm.reason,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_180, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                onClick: closeAdjust
              }, "닫기"),
              _createElementVNode("button", {
                type: "submit",
                class: "sui-btn sui-btn--primary",
                disabled: !canSubmitAdjust.value
              }, _toDisplayString(adjustBusy.value ? '처리 중…' : adjustSubmitLabel.value), 9, _hoisted_181)
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (refundTarget.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "aord__modal",
          onClick: _withModifiers(closeRefundDone, ["self"])
        }, [
          _createElementVNode("form", {
            class: "aord__refund-dialog",
            onSubmit: _withModifiers(submitRefundDone, ["prevent"])
          }, [
            _createElementVNode("header", null, [
              _createElementVNode("h3", null, [
                _createVNode(AppIcon, {
                  icon: "mdi-cash-refund",
                  size: 18
                }),
                _cache[117] || (_cache[117] = _createTextVNode(" 환불 완료 확인 ", -1))
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "aord__close",
                "aria-label": "닫기",
                onClick: closeRefundDone
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-close",
                  size: 18
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_182, [
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, _toDisplayString(expandedDetail.value?.code), 1),
                _createElementVNode("em", null, _toDisplayString(refundTarget.value.storeName) + " · " + _toDisplayString(refundTarget.value.name) + " · " + _toDisplayString(refundTarget.value.qty) + "개", 1),
                (refundTarget.value.claimReason)
                  ? (_openBlock(), _createElementBlock("em", _hoisted_183, "사유 " + _toDisplayString(refundTarget.value.claimReason), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("em", _hoisted_184, _toDisplayString(refundClaimLabelOf(refundTarget.value)), 1)
              ]),
              _createElementVNode("strong", _hoisted_185, _toDisplayString(_unref(formatWon)(refundTarget.value.refundAmount || refundTarget.value.amount)) + "원 ", 1)
            ]),
            _createElementVNode("p", _hoisted_186, _toDisplayString(expandedDetail.value?.payMethod === 'TOSS'
              ? '결제했던 카드·간편결제로 환불하고 완료로 표시합니다. 통장 송금은 없습니다.'
              : '아래 계좌로 송금했는지 확인한 뒤 완료로 표시합니다. 계좌가 비어 있으면 여기서 입력할 수 있습니다.'), 1),
            (expandedDetail.value?.payMethod !== 'TOSS')
              ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                  _createElementVNode("label", null, [
                    _cache[119] || (_cache[119] = _createElementVNode("span", null, "은행", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((refundForm.bank) = $event))
                    }, [
                      _cache[118] || (_cache[118] = _createElementVNode("option", {
                        value: "",
                        disabled: ""
                      }, "선택", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MALL_BANKS), (bank) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: bank,
                          value: bank
                        }, _toDisplayString(bank), 9, _hoisted_188))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, refundForm.bank]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[120] || (_cache[120] = _createElementVNode("span", null, "계좌번호", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((refundForm.account) = $event)),
                      type: "text",
                      inputmode: "numeric",
                      maxlength: "50"
                    }, null, 512), [
                      [
                        _vModelText,
                        refundForm.account,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[121] || (_cache[121] = _createElementVNode("span", null, "예금주", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((refundForm.holder) = $event)),
                      type: "text",
                      maxlength: "50"
                    }, null, 512), [
                      [
                        _vModelText,
                        refundForm.holder,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_189, [
                    _cache[122] || (_cache[122] = _createElementVNode("span", null, "메모 (선택)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((refundForm.memo) = $event)),
                      type: "text",
                      maxlength: "255",
                      placeholder: "송금 일시·담당자 등"
                    }, null, 512), [
                      [
                        _vModelText,
                        refundForm.memo,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_190, [
              _createElementVNode("button", {
                type: "button",
                class: "sui-btn",
                onClick: closeRefundDone
              }, "닫기"),
              _createElementVNode("button", {
                type: "submit",
                class: "sui-btn sui-btn--primary",
                disabled: 
              refundBusy.value ||
              (expandedDetail.value?.payMethod !== 'TOSS' &&
                (!refundForm.bank || !refundForm.account || !refundForm.holder))
            
              }, _toDisplayString(refundBusy.value
                ? '처리 중…'
                : expandedDetail.value?.payMethod === 'TOSS'
                  ? '카드 환불 완료'
                  : '송금 완료로 표시'), 9, _hoisted_191)
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true),
    (_unref(trackTarget))
      ? (_openBlock(), _createBlock(MallTrackingModal, {
          key: 5,
          "item-idx": _unref(trackTarget).idx,
          courier: _unref(trackTarget).courier,
          invoice: _unref(trackTarget).invoice,
          "product-name": _unref(trackTarget).name,
          "order-code": _unref(trackTarget).orderCode,
          onClose: onCloseTracking
        }, null, 8, ["item-idx", "courier", "invoice", "product-name", "order-code"]))
      : _createCommentVNode("", true),
    (taxTarget.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 6,
          class: "aord__modal aord__modal--tax",
          "data-tour": "admin-orders-tax-modal",
          onClick: _withModifiers(closeTaxModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_192, [
            _createElementVNode("header", _hoisted_193, [
              _createElementVNode("h2", null, [
                _cache[123] || (_cache[123] = _createTextVNode(" 세금계산서 ", -1)),
                _createElementVNode("em", null, _toDisplayString(taxTarget.value.code), 1)
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["sui-badge", taxToneOf(taxTarget.value)])
              }, _toDisplayString(taxLabelOf(taxTarget.value)), 3),
              _createElementVNode("button", {
                type: "button",
                class: "aord__close",
                "aria-label": "닫기",
                onClick: closeTaxModal
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-close",
                  size: 20
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_194, [
              (taxLoading.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_195, "불러오는 중…"))
                : (_openBlock(), _createElementBlock("dl", _hoisted_196, [
                    _createElementVNode("div", null, [
                      _cache[124] || (_cache[124] = _createElementVNode("dt", null, "주문번호", -1)),
                      _createElementVNode("dd", null, _toDisplayString(taxTarget.value.code), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[125] || (_cache[125] = _createElementVNode("dt", null, "발송대상 회원", -1)),
                      _createElementVNode("dd", null, _toDisplayString(taxTarget.value.orgName || '-'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[126] || (_cache[126] = _createElementVNode("dt", null, "수령인", -1)),
                      _createElementVNode("dd", null, _toDisplayString(taxTarget.value.receiver || '-'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[127] || (_cache[127] = _createElementVNode("dt", null, "휴대폰", -1)),
                      _createElementVNode("dd", null, [
                        (taxTarget.value.phone)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "aord__tax-phone",
                              href: `tel:${taxTarget.value.phone.replace(/\D/g, '')}`
                            }, _toDisplayString(_unref(formatKrPhone)(taxTarget.value.phone)), 9, _hoisted_197))
                          : (_openBlock(), _createElementBlock("span", _hoisted_198, "미입력"))
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[128] || (_cache[128] = _createElementVNode("dt", null, "입금자", -1)),
                      _createElementVNode("dd", null, _toDisplayString(taxTarget.value.depositor || taxTarget.value.receiver || '-'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[129] || (_cache[129] = _createElementVNode("dt", null, "입금액", -1)),
                      _createElementVNode("dd", null, _toDisplayString(_unref(formatWon)(taxTarget.value.totalAmount)) + "원", 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[130] || (_cache[130] = _createElementVNode("dt", null, "상호", -1)),
                      _createElementVNode("dd", null, _toDisplayString(taxTarget.value.bizName || '-'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[131] || (_cache[131] = _createElementVNode("dt", null, "사업자번호", -1)),
                      _createElementVNode("dd", null, _toDisplayString(taxTarget.value.bizNum || '-'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[132] || (_cache[132] = _createElementVNode("dt", null, "수신 이메일", -1)),
                      _createElementVNode("dd", null, [
                        (taxDisplayEmail(taxTarget.value))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("a", {
                                class: "aord__tax-email",
                                href: `mailto:${taxDisplayEmail(taxTarget.value)}`
                              }, _toDisplayString(taxDisplayEmail(taxTarget.value)), 9, _hoisted_199),
                              (!taxTarget.value.taxEmail && taxTarget.value.memberEmail)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_200, " 회원 프로필 "))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", _hoisted_201, "미입력"))
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[133] || (_cache[133] = _createElementVNode("dt", null, "사업자등록증", -1)),
                      _createElementVNode("dd", null, [
                        (taxDisplayBizCert(taxTarget.value))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("a", {
                                class: "aord__tax-doc",
                                href: bizCertHref(taxDisplayBizCert(taxTarget.value)!),
                                target: "_blank",
                                rel: "noopener"
                              }, "파일 보기", 8, _hoisted_202),
                              (!taxTarget.value.bizCert && taxTarget.value.memberBizCert)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_203, " 회원 프로필 "))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", _hoisted_204, "없음"))
                      ])
                    ]),
                    (effectiveTaxStatus(taxTarget.value) === 'DONE' && taxTarget.value.taxAt)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                          _cache[134] || (_cache[134] = _createElementVNode("dt", null, "발행 완료", -1)),
                          _createElementVNode("dd", null, _toDisplayString(formatDateTime(taxTarget.value.taxAt)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (taxTarget.value.taxStatus === 'DONE' && taxTarget.value.taxDocUrl)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
                          _cache[135] || (_cache[135] = _createElementVNode("dt", null, "발행 문서", -1)),
                          _createElementVNode("dd", null, [
                            _createElementVNode("a", {
                              href: taxDocHref(taxTarget.value.taxDocUrl),
                              target: "_blank",
                              rel: "noopener"
                            }, "세금계산서 보기", 8, _hoisted_207)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])),
              (!taxLoading.value && effectiveTaxStatus(taxTarget.value) === 'REQUESTED' && taxIssuesOf(taxTarget.value).length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_208, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxIssuesOf(taxTarget.value), (issue) => {
                      return (_openBlock(), _createElementBlock("li", { key: issue }, _toDisplayString(issue), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (!taxLoading.value && effectiveTaxStatus(taxTarget.value) === 'REQUESTED')
                ? (_openBlock(), _createElementBlock("p", _hoisted_209, " 수신 이메일과 사업자등록증을 확인한 뒤, 세금계산서를 발행했다면 「발행 완료」를 눌러 주세요. 정보에 문제가 있으면 「발행 요청 반려」로 안내 문자를 보낼 수 있습니다. "))
                : (!taxLoading.value && effectiveTaxStatus(taxTarget.value) === 'DONE')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_210, _toDisplayString(taxTarget.value.taxAt ? `${formatDateTime(taxTarget.value.taxAt)}에 발행 완료 처리했습니다.` : '발행 완료 상태입니다.') + " 잘못 처리했다면 「발행 완료 취소」로 되돌릴 수 있습니다. ", 1))
                  : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_211, [
                (effectiveTaxStatus(taxTarget.value) === 'REQUESTED')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "sui-btn sui-btn--primary",
                      "data-tour": "admin-orders-tax-done",
                      disabled: working.value === taxTarget.value.code || taxLoading.value,
                      onClick: _cache[33] || (_cache[33] = ($event: any) => (onTaxComplete(taxTarget.value)))
                    }, _toDisplayString(working.value === taxTarget.value.code ? '처리 중…' : '발행 완료'), 9, _hoisted_212))
                  : _createCommentVNode("", true),
                (effectiveTaxStatus(taxTarget.value) === 'DONE')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "sui-btn",
                      "data-tour": "admin-orders-tax-undo",
                      disabled: working.value === taxTarget.value.code || taxLoading.value,
                      onClick: _cache[34] || (_cache[34] = ($event: any) => (onTaxUndo(taxTarget.value)))
                    }, " 발행 완료 취소 ", 8, _hoisted_213))
                  : _createCommentVNode("", true),
                (effectiveTaxStatus(taxTarget.value) === 'REQUESTED')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "sui-btn sui-btn--ghost aord__tax-reject-btn",
                      "data-tour": "admin-orders-tax-reject",
                      disabled: working.value === taxTarget.value.code || taxLoading.value,
                      onClick: _cache[35] || (_cache[35] = ($event: any) => (openTaxReject(taxTarget.value)))
                    }, " 발행 요청 반려 ", 8, _hoisted_214))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "sui-btn sui-btn--ghost",
                  onClick: openDetailFromTax
                }, " 주문 펼치기 ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (taxRejectTarget.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 7,
          class: "aord__modal aord__modal--tax-reject",
          "data-tour": "admin-orders-tax-reject-modal",
          onClick: _withModifiers(closeTaxReject, ["self"])
        }, [
          _createElementVNode("div", _hoisted_215, [
            _createElementVNode("header", _hoisted_216, [
              _cache[136] || (_cache[136] = _createElementVNode("h2", null, "발행 요청 반려", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "aord__close",
                "aria-label": "닫기",
                onClick: closeTaxReject
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-close",
                  size: 20
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_217, [
              _createElementVNode("p", _hoisted_218, _toDisplayString(taxRejectTarget.value.code) + " · " + _toDisplayString(taxRejectTarget.value.orgName || taxRejectTarget.value.receiver), 1),
              _createElementVNode("section", _hoisted_219, [
                _cache[138] || (_cache[138] = _createElementVNode("h3", null, "확인된 문제", -1)),
                _createElementVNode("ul", _hoisted_220, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxRejectIssues.value, (issue) => {
                    return (_openBlock(), _createElementBlock("li", { key: issue }, _toDisplayString(issue), 1))
                  }), 128))
                ]),
                _createElementVNode("label", _hoisted_221, [
                  _cache[137] || (_cache[137] = _createElementVNode("span", null, "추가 사유 (선택)", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((taxRejectExtra).value = $event)),
                    type: "text",
                    maxlength: "200",
                    placeholder: "예: 사업자등록증 화질이 낮습니다"
                  }, null, 512), [
                    [
                      _vModelText,
                      taxRejectExtra.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_222, [
                _cache[139] || (_cache[139] = _createElementVNode("h3", null, "안내 문자", -1)),
                _createElementVNode("label", _hoisted_223, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((taxRejectSms).value = $event)),
                    rows: "9",
                    maxlength: "2000"
                  }, null, 512), [
                    [_vModelText, taxRejectSms.value]
                  ])
                ]),
                _createElementVNode("label", _hoisted_224, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((taxRejectSendSms).value = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, taxRejectSendSms.value]
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_unref(formatKrPhone)(taxRejectTarget.value.phone) || '휴대폰 미입력') + "로 문자 보내기", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_225, [
                _createElementVNode("button", {
                  type: "button",
                  class: "sui-btn",
                  onClick: closeTaxReject
                }, "닫기"),
                _createElementVNode("button", {
                  type: "button",
                  class: "sui-btn sui-btn--primary",
                  disabled: !taxRejectIssues.value.length || working.value === taxRejectTarget.value.code,
                  onClick: submitTaxReject
                }, _toDisplayString(working.value === taxRejectTarget.value.code
                  ? '처리 중…'
                  : taxRejectSendSms.value
                    ? '반려 · 문자 보내기'
                    : '반려하기'), 9, _hoisted_226)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (orgModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 8,
          class: "aord__modal",
          "data-tour": "admin-orders-org-modal",
          onClick: _withModifiers(closeOrgDetail, ["self"])
        }, [
          _createElementVNode("div", _hoisted_227, [
            _createElementVNode("header", _hoisted_228, [
              _createElementVNode("h2", null, [
                _cache[140] || (_cache[140] = _createTextVNode(" 회원정보 ", -1)),
                (orgDetail.value?.orgName)
                  ? (_openBlock(), _createElementBlock("em", _hoisted_229, _toDisplayString(orgDetail.value.orgName), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "aord__close",
                "aria-label": "닫기",
                onClick: closeOrgDetail
              }, [
                _createVNode(AppIcon, {
                  icon: "mdi-close",
                  size: 20
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_230, [
              (orgLoading.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_231, "불러오는 중…"))
                : (orgError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_232, _toDisplayString(orgError.value), 1))
                  : (orgDetail.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("section", _hoisted_233, [
                          _cache[150] || (_cache[150] = _createElementVNode("h3", { class: "aord__org-section-title" }, "기본 정보", -1)),
                          _createElementVNode("dl", _hoisted_234, [
                            _createElementVNode("div", null, [
                              _cache[141] || (_cache[141] = _createElementVNode("dt", null, "회원명", -1)),
                              _createElementVNode("dd", null, _toDisplayString(orgDetail.value.orgName || '-'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[142] || (_cache[142] = _createElementVNode("dt", null, "장기요양기관기호", -1)),
                              _createElementVNode("dd", null, _toDisplayString(orgDetail.value.longtermCode || '-'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[143] || (_cache[143] = _createElementVNode("dt", null, "로그인 아이디", -1)),
                              _createElementVNode("dd", null, _toDisplayString(orgDetail.value.userId || '-'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[144] || (_cache[144] = _createElementVNode("dt", null, "로그인 방식", -1)),
                              _createElementVNode("dd", null, [
                                _createTextVNode(_toDisplayString(orgDetail.value.loginType === 'kakao' ? '카카오' : '비밀번호') + " ", 1),
                                (orgDetail.value.oauthEmail)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" · " + _toDisplayString(orgDetail.value.oauthEmail), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _cache[145] || (_cache[145] = _createElementVNode("dt", null, "대표자", -1)),
                              _createElementVNode("dd", null, _toDisplayString(orgDetail.value.bossName || '-'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[146] || (_cache[146] = _createElementVNode("dt", null, "대표 연락처", -1)),
                              _createElementVNode("dd", null, _toDisplayString(_unref(formatKrPhone)(orgDetail.value.bossPhone) || orgDetail.value.bossPhone || '-'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[147] || (_cache[147] = _createElementVNode("dt", null, "전화", -1)),
                              _createElementVNode("dd", null, _toDisplayString(_unref(formatKrPhone)(orgDetail.value.orgPhone || '') || orgDetail.value.orgPhone || '-'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[148] || (_cache[148] = _createElementVNode("dt", null, "이메일", -1)),
                              _createElementVNode("dd", null, _toDisplayString(orgDetail.value.bossEmail || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_235, [
                              _cache[149] || (_cache[149] = _createElementVNode("dt", null, "주소", -1)),
                              _createElementVNode("dd", null, [
                                (orgDetail.value.address || orgDetail.value.zipcode)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (orgDetail.value.zipcode)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_236, "(" + _toDisplayString(orgDetail.value.zipcode) + ") ", 1))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(" " + _toDisplayString(orgDetail.value.address || '') + " " + _toDisplayString(orgDetail.value.addressDetail || ''), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("-")
                                    ], 64))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("section", _hoisted_237, [
                          _cache[155] || (_cache[155] = _createElementVNode("h3", { class: "aord__org-section-title" }, "사업자 · 환불", -1)),
                          _createElementVNode("dl", _hoisted_238, [
                            _createElementVNode("div", null, [
                              _cache[151] || (_cache[151] = _createElementVNode("dt", null, "사업구분", -1)),
                              _createElementVNode("dd", null, _toDisplayString(orgDetail.value.bizGubun || '-'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[152] || (_cache[152] = _createElementVNode("dt", null, "사업자번호", -1)),
                              _createElementVNode("dd", null, _toDisplayString(orgDetail.value.bizNum || '-'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[153] || (_cache[153] = _createElementVNode("dt", null, "사업자등록증", -1)),
                              _createElementVNode("dd", null, [
                                (orgDetail.value.bizCert)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "aord__tax-doc",
                                      href: bizCertHref(orgDetail.value.bizCert),
                                      target: "_blank",
                                      rel: "noopener"
                                    }, "파일 보기", 8, _hoisted_239))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_240, "-"))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_241, [
                              _cache[154] || (_cache[154] = _createElementVNode("dt", null, "환불 계좌", -1)),
                              _createElementVNode("dd", null, [
                                (orgDetail.value.refundBank || orgDetail.value.refundAccount)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(orgDetail.value.refundBank || '') + " " + _toDisplayString(orgDetail.value.refundAccount || '') + " ", 1),
                                      (orgDetail.value.refundHolder)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(" (" + _toDisplayString(orgDetail.value.refundHolder) + ")", 1)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("-")
                                    ], 64))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("section", _hoisted_242, [
                          _cache[164] || (_cache[164] = _createElementVNode("h3", { class: "aord__org-section-title" }, "가입 · 인증", -1)),
                          _createElementVNode("dl", _hoisted_243, [
                            _createElementVNode("div", null, [
                              _cache[156] || (_cache[156] = _createElementVNode("dt", null, "가입 경로", -1)),
                              _createElementVNode("dd", null, _toDisplayString(orgDetail.value.signupSource === 'WEB' ? '쇼핑몰' : orgDetail.value.signupSource || '-'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[157] || (_cache[157] = _createElementVNode("dt", null, "권한", -1)),
                              _createElementVNode("dd", null, _toDisplayString(orgDetail.value.roleName || orgDetail.value.roleCode || '-'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[158] || (_cache[158] = _createElementVNode("dt", null, "가입일", -1)),
                              _createElementVNode("dd", null, _toDisplayString(formatOrgDate(orgDetail.value.joinedAt)), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[159] || (_cache[159] = _createElementVNode("dt", null, "이메일 인증", -1)),
                              _createElementVNode("dd", null, _toDisplayString(orgDetail.value.emailVerified ? '완료' : '미완료'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[160] || (_cache[160] = _createElementVNode("dt", null, "휴대폰 인증", -1)),
                              _createElementVNode("dd", null, _toDisplayString(orgDetail.value.phoneVerified ? '완료' : '미완료'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[161] || (_cache[161] = _createElementVNode("dt", null, "약관 동의", -1)),
                              _createElementVNode("dd", null, _toDisplayString(orgDetail.value.termsAgreed ? '동의' : '미동의'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[162] || (_cache[162] = _createElementVNode("dt", null, "마케팅 동의", -1)),
                              _createElementVNode("dd", null, _toDisplayString(orgDetail.value.marketingAgreed ? '동의' : '미동의'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[163] || (_cache[163] = _createElementVNode("dt", null, "주문 실적", -1)),
                              _createElementVNode("dd", null, [
                                _createTextVNode(" 전체 " + _toDisplayString(orgDetail.value.orderCount || 0) + "건 · 결제확인 " + _toDisplayString(orgDetail.value.paidCount || 0) + "건 ", 1),
                                ((orgDetail.value.orderAmount || 0) > 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" · " + _toDisplayString(_unref(formatWon)(orgDetail.value.orderAmount || 0)) + "원 ", 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (orgDetail.value.lastOrderedAt)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_244, " 최근 " + _toDisplayString(formatOrgDate(orgDetail.value.lastOrderedAt)), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("section", _hoisted_245, [
                          _createElementVNode("h3", _hoisted_246, [
                            _cache[165] || (_cache[165] = _createTextVNode(" 세금계산서 요청 ", -1)),
                            (orgTaxRequests.value.length)
                              ? (_openBlock(), _createElementBlock("em", _hoisted_247, _toDisplayString(orgTaxRequests.value.length) + "건", 1))
                              : _createCommentVNode("", true)
                          ]),
                          (!orgTaxRequests.value.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_248, "세금계산서 발행 요청 내역이 없습니다."))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orgTaxRequests.value, (tax) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: tax.orderCode,
                              class: _normalizeClass(["aord__org-tax-card", { 'is-focus': orgFocusOrderCode.value === tax.orderCode }])
                            }, [
                              _createElementVNode("header", _hoisted_249, [
                                _createElementVNode("strong", null, _toDisplayString(tax.orderCode), 1),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["sui-badge", memberTaxTone(tax.taxStatus)])
                                }, _toDisplayString(taxStatusLabel(tax.taxStatus)), 3)
                              ]),
                              _createElementVNode("dl", _hoisted_250, [
                                _createElementVNode("div", null, [
                                  _cache[166] || (_cache[166] = _createElementVNode("dt", null, "주문일시", -1)),
                                  _createElementVNode("dd", null, _toDisplayString(formatDateTime(tax.orderedAt || null)), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[167] || (_cache[167] = _createElementVNode("dt", null, "입금액", -1)),
                                  _createElementVNode("dd", null, _toDisplayString(_unref(formatWon)(tax.totalAmount || 0)) + "원", 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[168] || (_cache[168] = _createElementVNode("dt", null, "상호", -1)),
                                  _createElementVNode("dd", null, _toDisplayString(tax.bizName || '-'), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[169] || (_cache[169] = _createElementVNode("dt", null, "사업자번호", -1)),
                                  _createElementVNode("dd", null, _toDisplayString(tax.bizNum || '-'), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[170] || (_cache[170] = _createElementVNode("dt", null, "수신 이메일", -1)),
                                  _createElementVNode("dd", null, [
                                    (tax.taxEmail || orgDetail.value.bossEmail)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "aord__tax-email",
                                          href: `mailto:${tax.taxEmail || orgDetail.value.bossEmail}`
                                        }, _toDisplayString(tax.taxEmail || orgDetail.value.bossEmail), 9, _hoisted_251))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_252, "-")),
                                    (!tax.taxEmail && orgDetail.value.bossEmail)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_253, "회원 프로필"))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[171] || (_cache[171] = _createElementVNode("dt", null, "사업자등록증", -1)),
                                  _createElementVNode("dd", null, [
                                    (tax.bizCert || orgDetail.value.bizCert)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "aord__tax-doc",
                                          href: bizCertHref(tax.bizCert || orgDetail.value.bizCert || ''),
                                          target: "_blank",
                                          rel: "noopener"
                                        }, "파일 보기", 8, _hoisted_254))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_255, "-")),
                                    (!tax.bizCert && orgDetail.value.bizCert)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_256, "회원 프로필"))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[172] || (_cache[172] = _createElementVNode("dt", null, "입금자", -1)),
                                  _createElementVNode("dd", null, _toDisplayString(tax.depositor || tax.receiver || '-'), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[173] || (_cache[173] = _createElementVNode("dt", null, "수령인 · 연락처", -1)),
                                  _createElementVNode("dd", null, [
                                    _createTextVNode(_toDisplayString(tax.receiver || '-') + " ", 1),
                                    (tax.phone)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" · " + _toDisplayString(_unref(formatKrPhone)(tax.phone) || tax.phone), 1)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                (tax.taxAt)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_257, [
                                      _cache[174] || (_cache[174] = _createElementVNode("dt", null, "처리일시", -1)),
                                      _createElementVNode("dd", null, _toDisplayString(formatDateTime(tax.taxAt)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (tax.taxDocUrl)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_258, [
                                      _cache[175] || (_cache[175] = _createElementVNode("dt", null, "발행 문서", -1)),
                                      _createElementVNode("dd", null, [
                                        _createElementVNode("a", {
                                          class: "aord__tax-doc",
                                          href: taxDocHref(tax.taxDocUrl),
                                          target: "_blank",
                                          rel: "noopener"
                                        }, "세금계산서 보기", 8, _hoisted_259)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (tax.taxRejectReason)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_260, [
                                      _cache[176] || (_cache[176] = _createElementVNode("dt", null, "반려 사유", -1)),
                                      _createElementVNode("dd", null, _toDisplayString(tax.taxRejectReason), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2))
                          }), 128))
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})